(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cart-reward-bar"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('cart-reward-bar')) {
    class CartRewardBar extends HTMLElement {
      connectedCallback() {
        this.refreshElements();
        this.handleCartEvent = (event) => {
          const candidate = event.detail?.resource || event.detail?.cart;
          this.consumeCart(candidate);
        };
        document.addEventListener('cart:update', this.handleCartEvent);
        const snapshot = window.TBHNPCartRewards?.snapshot;
        if (this.isFullCart(snapshot)) {
          this.renderCart(snapshot);
        } else {
          this.consumeCart(snapshot);
        }
      }

      disconnectedCallback() {
        document.removeEventListener('cart:update', this.handleCartEvent);
      }

      refreshElements() {
        this.headline = this.querySelector('[data-reward-headline]');
        this.subline = this.querySelector('[data-reward-subline]');
        this.saving = this.querySelector('[data-reward-saving]');
        this.savingAmount = this.querySelector('[data-reward-saving-amount]');
        this.visual = this.querySelector('[data-reward-visual]');
        this.discount = this.querySelector('[data-reward-discount]');
        this.product = this.querySelector('[data-reward-product]');
        this.unlocked = this.querySelector('[data-reward-unlocked]');
        this.unlockedLabel = this.querySelector('[data-reward-unlocked-label]');
        this.unlockedSummary = this.querySelector('[data-reward-unlocked-summary]');
        this.copy = {
          labels: {
            shipping: this.dataset.labelShipping || '',
            discount10: this.dataset.labelDiscount10 || '',
            mystery: this.dataset.labelMystery || '',
            discount15: this.dataset.labelDiscount15 || ''
          },
          messages: {
            shipping: this.dataset.messageShipping || '',
            discount10: this.dataset.messageDiscount10 || '',
            mystery: this.dataset.messageMystery || '',
            discount15: this.dataset.messageDiscount15 || '',
            freeTee: this.dataset.messageFreeTee || ''
          },
          addOne: this.dataset.copyAddOne || '',
          addTwo: this.dataset.copyAddTwo || '',
          unlocked: this.dataset.copyUnlocked || '',
          alsoUnlocked: this.dataset.copyAlsoUnlocked || '',
          freeTeeUnlocked: this.dataset.copyFreeTeeUnlocked || '',
          addingFreeTee: this.dataset.copyAddingFreeTee || '',
          sizeSelected: {
            S: this.dataset.copySizeSelectedS || '',
            M: this.dataset.copySizeSelectedM || '',
            L: this.dataset.copySizeSelectedL || '',
            XL: this.dataset.copySizeSelectedXl || ''
          },
          selectSizeInCart: this.dataset.copySelectSizeInCart || ''
        };
      }

      isFullCart(cart) {
        if (window.TBHNPCartRewards?.isFullCart) return window.TBHNPCartRewards.isFullCart(cart);
        return Boolean(cart && Array.isArray(cart.items));
      }

      async consumeCart(candidate) {
        try {
          let cart;
          if (window.TBHNPCartRewards) {
            cart = await window.TBHNPCartRewards.resolve(candidate);
          } else if (this.isFullCart(candidate)) {
            cart = candidate;
          } else {
            const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart.js`, {
              credentials: 'same-origin',
              headers: { Accept: 'application/json' }
            });
            if (!response.ok) return;
            cart = await response.json();
          }
          if (this.isConnected) this.renderCart(cart);
        } catch (error) {}
      }

      qualifyingQuantity(cart) {
        if (window.TBHNPCartRewards?.qualifyingQuantity) {
          return window.TBHNPCartRewards.qualifyingQuantity(cart);
        }
        return (cart.items || []).reduce((quantity, item) => {
          const variantId = String(item.variant_id || item.id || '');
          if (item.properties?._free_tee_reward === 'true') return quantity;
          if (item.properties?._mystery_gift_reward === 'true') return quantity;
          if (variantId === '53972593148088' || variantId === '53776651026616') return quantity;
          return quantity + Number(item.quantity || 0);
        }, 0);
      }

      stateFor(quantity) {
        const tiers = [
          { threshold: 2, message: this.copy.messages.shipping, visual: 'shipping' },
          { threshold: 3, message: this.copy.messages.discount10, visual: 'discount', badge: '10%' },
          { threshold: 4, message: this.copy.messages.mystery, visual: 'mystery' },
          { threshold: 5, message: this.copy.messages.discount15, visual: 'discount', badge: '15%' },
          { threshold: 6, message: this.copy.messages.freeTee, visual: 'tee' }
        ];
        const next = tiers.find((tier) => quantity < tier.threshold);
        const unlocked = [];
        if (quantity >= 2) unlocked.push(this.copy.labels.shipping);
        if (quantity >= 5) {
          unlocked.push(this.copy.labels.discount15);
        } else if (quantity >= 3) {
          unlocked.push(this.copy.labels.discount10);
        }
        if (quantity >= 4) unlocked.push(this.copy.labels.mystery);
        return { next, unlocked, final: quantity >= 6 };
      }

      renderCart(cart) {
        this.refreshElements();
        if (!this.headline || !this.subline || !this.visual || !this.unlocked) return;
        const quantity = this.qualifyingQuantity(cart);
        const state = this.stateFor(quantity);
        if (this.saving && this.savingAmount) {
          const lineSavings = (cart.items || []).reduce((sum, item) => {
            const variantId = String(item.variant_id || item.id || '');
            if (item.properties?._free_tee_reward === 'true' || item.properties?._mystery_gift_reward === 'true' || variantId === '53972593148088' || variantId === '53776651026616') return sum;
            return sum + (item.line_level_discount_allocations || []).reduce((amount, allocation) => amount + Number(allocation.amount || 0), 0);
          }, 0);
          const orderSavings = (cart.cart_level_discount_applications || []).reduce((sum, application) => application.target_type === 'line_item' ? sum + Number(application.total_allocated_amount || 0) : sum, 0);
          const saved = Math.max(0, Math.round(lineSavings + orderSavings));
          this.saving.hidden = quantity < 3 || saved <= 0;
          if (!this.saving.hidden) {
            const currency = cart.currency || this.dataset.currency || window.Shopify?.currency?.active || 'USD';
            try {
              this.savingAmount.textContent = new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency, currencyDisplay: 'code' }).format(saved / 100);
            } catch (error) {
              this.savingAmount.textContent = (saved / 100).toFixed(2) + ' ' + currency;
            }
          }
        }

        this.classList.toggle('is-final', state.final);
        this.unlocked.classList.toggle('is-hidden', state.unlocked.length === 0);
        this.unlockedLabel.textContent = state.final ? this.copy.alsoUnlocked : this.copy.unlocked;
        this.unlockedSummary.textContent = state.unlocked.join(' · ');

        if (state.next) {
          const remaining = state.next.threshold - quantity;
          this.headline.textContent = remaining === 1 ? this.copy.addOne : this.copy.addTwo;
          this.subline.textContent = state.next.message;
          this.visual.dataset.kind = state.next.visual;
          if (state.next.badge) this.discount.textContent = state.next.badge;
          if (state.next.visual === 'mystery') this.product.src = this.dataset.imageMystery;
          if (state.next.visual === 'tee') this.product.src = this.dataset.imageTee;
        } else {
          const freeTee = (cart.items || []).find(
            (item) =>
              String(item.variant_id || item.id) === '53972593148088' &&
              item.properties?._free_tee_reward === 'true' &&
              Number(item.quantity) === 1 &&
              Number(item.final_line_price) === 0
          );
          const freeTeeSize = String(freeTee?.properties?.Size || '').toUpperCase();
          this.headline.textContent = this.copy.freeTeeUnlocked;
          if (!freeTee) {
            this.subline.textContent = this.copy.addingFreeTee;
          } else if (['S', 'M', 'L', 'XL'].includes(freeTeeSize)) {
            this.subline.textContent = this.copy.sizeSelected[freeTeeSize];
          } else {
            this.subline.textContent = this.copy.selectSizeInCart;
          }
          this.visual.dataset.kind = 'tee';
          this.product.src = this.dataset.imageTee;
        }

        this.dataset.quantity = String(quantity);
      }
    }

    customElements.define('cart-reward-bar', CartRewardBar);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["free-tee-gift-manager"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('free-tee-gift-manager')) {
    class FreeTeeGiftManager extends HTMLElement {
      connectedCallback() {
        this.checkoutOwner = 'tbhnp-free-tee';
        this.sizeOwner = 'tbhnp-free-tee-size';
        window.TBHNPCartRewards?.setCheckoutBlocked(this.checkoutOwner, true);
        this.handleCartEvent = (event) => {
          if (event.detail?.data?.source === 'free-tee-gift-manager') return;
          this.consumeCart(event.detail?.resource || event.detail?.cart);
        };
        this.handleSizeClick = (event) => {
          const button = event.target.closest?.('[data-free-tee-size]');
          if (!button || button.disabled) return;
          event.preventDefault();
          this.selectSize(button);
        };
        document.addEventListener('cart:update', this.handleCartEvent);
        document.addEventListener('click', this.handleSizeClick);
        this.consumeCart(window.TBHNPCartRewards?.snapshot);
      }

      disconnectedCallback() {
        document.removeEventListener('cart:update', this.handleCartEvent);
        document.removeEventListener('click', this.handleSizeClick);
        window.TBHNPCartRewards?.setCheckoutBlocked(this.checkoutOwner, false);
        window.TBHNPCartRewards?.setCheckoutBlocked(this.sizeOwner, false);
      }

      async consumeCart(candidate) {
        this.pendingCandidate = candidate;
        this.hasPendingCandidate = true;
        if (this.consumePromise) return this.consumePromise;

        this.consumePromise = (async () => {
          while (this.hasPendingCandidate && this.isConnected) {
            const nextCandidate = this.pendingCandidate;
            this.pendingCandidate = null;
            this.hasPendingCandidate = false;

            try {
              let cart;
              if (window.TBHNPCartRewards) {
                cart = await window.TBHNPCartRewards.resolve(nextCandidate);
              } else if (nextCandidate?.items && nextCandidate.item_count !== undefined) {
                cart = nextCandidate;
              } else {
                cart = await this.fetchCart();
              }
              if (cart && this.isConnected) await this.reconcile(cart);
            } catch (error) {
              window.TBHNPCartRewards?.setCheckoutBlocked(this.checkoutOwner, true);
              console.error('Unable to reconcile the Free T-shirt reward', error);
            }
          }
        })().finally(() => {
          this.consumePromise = null;
          if (this.hasPendingCandidate && this.isConnected) this.consumeCart(this.pendingCandidate);
        });

        return this.consumePromise;
      }

      qualifyingQuantity(cart) {
        if (window.TBHNPCartRewards?.qualifyingQuantity) {
          return window.TBHNPCartRewards.qualifyingQuantity(cart);
        }
        return (cart.items || []).reduce((quantity, item) => {
          if (item.properties?._free_tee_reward === 'true') return quantity;
          if (item.properties?._mystery_gift_reward === 'true') return quantity;
          if (['53776651026616', '53972593148088'].includes(String(item.variant_id || item.id))) {
            return quantity;
          }
          return quantity + Number(item.quantity || 0);
        }, 0);
      }

      giftItems(cart) {
        return (cart.items || []).filter(
          (item) =>
            String(item.variant_id || item.id) === this.dataset.variantId ||
            item.properties?._free_tee_reward === 'true'
        );
      }

      isStructurallyValid(item) {
        return Boolean(
          item &&
            String(item.variant_id || item.id) === this.dataset.variantId &&
            item.properties?._free_tee_reward === 'true' &&
            String(item.properties?._reward_tier) === '6' &&
            Number(item.quantity) === 1 &&
            Number(item.final_line_price) === 0
        );
      }

      hasValidSize(item) {
        if (window.TBHNPCartRewards?.hasValidFreeTeeSize) {
          return window.TBHNPCartRewards.hasValidFreeTeeSize(item);
        }
        return ['S', 'M', 'L', 'XL'].includes(String(item?.properties?.Size || '').toUpperCase());
      }

      updateCheckoutState(qualified, gifts) {
        const gift = gifts.length === 1 && this.isStructurallyValid(gifts[0]) ? gifts[0] : null;
        window.TBHNPCartRewards?.setCheckoutBlocked(this.checkoutOwner, qualified && !gift);
        window.TBHNPCartRewards?.setCheckoutBlocked(
          this.sizeOwner,
          Boolean(qualified && gift && !this.hasValidSize(gift))
        );
        return gift;
      }

      async reconcile(cart) {
        if (this.reconciling) return;

        const qualified = this.qualifyingQuantity(cart) >= Number(this.dataset.threshold);
        const gifts = this.giftItems(cart);
        const gift = this.updateCheckoutState(qualified, gifts);
        if ((qualified && gift) || (!qualified && gifts.length === 0)) return;

        window.TBHNPCartRewards?.setCheckoutBlocked(this.checkoutOwner, true);
        this.reconciling = true;
        const reconcileGift = async () => {
          const currentCart = window.TBHNPCartRewards
            ? await window.TBHNPCartRewards.get(true)
            : await this.fetchCart();
          const currentQualified =
            this.qualifyingQuantity(currentCart) >= Number(this.dataset.threshold);
          const currentGifts = this.giftItems(currentCart);
          const currentGift =
            currentGifts.length === 1 && this.isStructurallyValid(currentGifts[0])
              ? currentGifts[0]
              : null;
          if ((currentQualified && currentGift) || (!currentQualified && currentGifts.length === 0)) {
            return currentCart;
          }

          let nextCart = currentCart;
          if (currentGifts.length) {
            nextCart = await this.removeGifts(currentGifts, !currentQualified);
          }
          if (currentQualified) nextCart = await this.addGift();
          return nextCart;
        };

        try {
          const nextCart = window.TBHNPCartRewards
            ? await window.TBHNPCartRewards.enqueue(reconcileGift)
            : await reconcileGift();
          const nextQualified = Boolean(
            nextCart && this.qualifyingQuantity(nextCart) >= Number(this.dataset.threshold)
          );
          this.updateCheckoutState(nextQualified, nextCart ? this.giftItems(nextCart) : []);
        } catch (error) {
          console.error('Unable to update the Free T-shirt reward', error);
        } finally {
          this.reconciling = false;
        }
      }

      async selectSize(button) {
        const size = String(button.dataset.freeTeeSize || '').toUpperCase();
        if (!['S', 'M', 'L', 'XL'].includes(size)) return;

        const selector = button.closest('[data-free-tee-size-selector]');
        if (!selector) return;

        window.TBHNPCartRewards?.setCheckoutBlocked(this.sizeOwner, true);
        selector.setAttribute('aria-busy', 'true');
        this.setSizeStatus(
          selector,
          selector.getAttribute(`data-free-tee-saving-${size.toLowerCase()}`) || ''
        );

        const updateSize = async () => {
          const currentCart = window.TBHNPCartRewards
            ? await window.TBHNPCartRewards.get(true)
            : await this.fetchCart();
          const currentGift = this.giftItems(currentCart).find((item) =>
            this.isStructurallyValid(item)
          );
          if (!currentGift) throw new Error('The Free T-shirt line is still being prepared');
          const properties = {
            ...(currentGift.properties || {}),
            _free_tee_reward: 'true',
            _reward_tier: '6',
            Size: size
          };
          const result = await this.requestJSON(this.cartUrl('change'), {
            method: 'POST',
            headers: {'Content-Type': 'application/json', Accept: 'application/json'},
            body: JSON.stringify({
              id: currentGift.key,
              quantity: 1,
              properties,
              sections: this.sectionIds().join(','),
              sections_url: window.location.pathname
            })
          });
          this.dispatchUpdate(result, result.sections || {}, 'free-tee-size');
          return result;
        };

        try {
          const cart = window.TBHNPCartRewards
            ? await window.TBHNPCartRewards.selectReward(updateSize)
            : await updateSize();
          const selected = this.giftItems(cart).find(
            (item) => this.isStructurallyValid(item) && this.hasValidSize(item)
          );
          if (!selected || String(selected.properties?.Size).toUpperCase() !== size) {
            throw new Error('Selected size was not confirmed by the cart');
          }
          window.TBHNPCartRewards?.setCheckoutBlocked(this.sizeOwner, false);
        } catch (error) {
          selector.removeAttribute('aria-busy');
          this.setSizeStatus(selector, selector.dataset.freeTeeSaveError || '');
          console.error('Unable to save the Free T-shirt size', error);
        }
      }

      setSizeStatus(selector, text) {
        const status = selector.querySelector('[data-free-tee-size-status]');
        if (status) status.textContent = text;
      }

      sectionIds() {
        return Array.from(document.querySelectorAll('cart-items-component[data-section-id]'))
          .map((element) => element.dataset.sectionId)
          .filter(Boolean);
      }

      cartUrl(action) {
        return `${window.Shopify?.routes?.root || '/'}cart/${action}.js`;
      }

      async requestJSON(url, options = {}) {
        const response = await fetch(url, {credentials: 'same-origin', ...options});
        const responseText = await response.text();
        let result;

        try {
          result = JSON.parse(responseText);
        } catch (error) {
          throw new Error(`Free T-shirt cart response was not valid JSON (${response.status})`);
        }

        if (!response.ok || !result || typeof result !== 'object' || result.status || result.errors) {
          throw new Error(result?.description || result?.message || 'Free T-shirt cart request failed');
        }
        return result;
      }

      async fetchCart() {
        const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart.js`, {
          credentials: 'same-origin',
          headers: {Accept: 'application/json'}
        });
        if (!response.ok) throw new Error('Unable to refresh cart');
        return response.json();
      }

      async addGift() {
        const result = await this.requestJSON(this.cartUrl('add'), {
          method: 'POST',
          headers: {'Content-Type': 'application/json', Accept: 'application/json'},
          body: JSON.stringify({
            items: [
              {
                id: this.dataset.variantId,
                quantity: 1,
                properties: {
                  _free_tee_reward: 'true',
                  _reward_tier: '6',
                  Size: 'Select size'
                }
              }
            ],
            sections: this.sectionIds().join(','),
            sections_url: window.location.pathname
          })
        });
        const cart = window.TBHNPCartRewards
          ? await window.TBHNPCartRewards.get(true)
          : await this.fetchCart();
        this.dispatchUpdate(cart, result.sections || {});
        return cart;
      }

      async removeGifts(gifts, shouldDispatch = true) {
        const updates = {};
        gifts.forEach((item) => {
          updates[item.key] = 0;
        });
        const result = await this.requestJSON(this.cartUrl('update'), {
          method: 'POST',
          headers: {'Content-Type': 'application/json', Accept: 'application/json'},
          body: JSON.stringify({
            updates,
            sections: this.sectionIds().join(','),
            sections_url: window.location.pathname
          })
        });
        if (shouldDispatch) this.dispatchUpdate(result, result.sections || {});
        return result;
      }

      dispatchUpdate(cart, sections, source = 'free-tee-gift-manager') {
        window.TBHNPCartRewards?.set(cart);
        document.dispatchEvent(
          new CustomEvent('cart:update', {
            bubbles: true,
            detail: {resource: cart, data: {source, sections}}
          })
        );
      }
    }

    customElements.define('free-tee-gift-manager', FreeTeeGiftManager);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["mystery-gift-manager"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('mystery-gift-manager')) {
    class MysteryGiftManager extends HTMLElement {
      connectedCallback() {
        this.checkoutOwner = 'tbhnp-mystery-gift';
        window.TBHNPCartRewards?.setCheckoutBlocked(this.checkoutOwner, true);
        this.handleCartEvent = (event) => {
          if (event.detail?.data?.source === 'mystery-gift-manager') return;
          this.consumeCart(event.detail?.resource || event.detail?.cart);
        };
        document.addEventListener('cart:update', this.handleCartEvent);
        this.consumeCart(window.TBHNPCartRewards?.snapshot);
      }

      disconnectedCallback() {
        document.removeEventListener('cart:update', this.handleCartEvent);
        window.TBHNPCartRewards?.setCheckoutBlocked(this.checkoutOwner, false);
      }

      async consumeCart(candidate) {
        this.pendingCandidate = candidate;
        this.hasPendingCandidate = true;
        if (this.consumePromise) return this.consumePromise;

        this.consumePromise = (async () => {
          while (this.hasPendingCandidate && this.isConnected) {
            const nextCandidate = this.pendingCandidate;
            this.pendingCandidate = null;
            this.hasPendingCandidate = false;

            try {
              let cart;
              if (window.TBHNPCartRewards) {
                cart = await window.TBHNPCartRewards.resolve(nextCandidate);
              } else if (nextCandidate?.items && nextCandidate.item_count !== undefined) {
                cart = nextCandidate;
              } else {
                cart = await this.fetchCart();
              }
              if (cart && this.isConnected) await this.reconcile(cart);
            } catch (error) {
              window.TBHNPCartRewards?.setCheckoutBlocked(this.checkoutOwner, true);
              console.error('Unable to reconcile the Mystery Gift reward', error);
            }
          }
        })().finally(() => {
          this.consumePromise = null;
          if (this.hasPendingCandidate && this.isConnected) this.consumeCart(this.pendingCandidate);
        });

        return this.consumePromise;
      }

      qualifyingQuantity(cart) {
        if (window.TBHNPCartRewards?.qualifyingQuantity) {
          return window.TBHNPCartRewards.qualifyingQuantity(cart);
        }
        return (cart.items || []).reduce((quantity, item) => {
          if (item.properties?._free_tee_reward === 'true') return quantity;
          if (item.properties?._mystery_gift_reward === 'true') return quantity;
          if (['53776651026616', '53972593148088'].includes(String(item.variant_id || item.id))) {
            return quantity;
          }
          return quantity + Number(item.quantity || 0);
        }, 0);
      }

      giftItems(cart) {
        return (cart.items || []).filter(
          (item) =>
            String(item.variant_id || item.id) === this.dataset.variantId ||
            item.properties?._mystery_gift_reward === 'true'
        );
      }

      isValidGift(item) {
        return Boolean(
          item &&
            String(item.variant_id || item.id) === this.dataset.variantId &&
            item.properties?._mystery_gift_reward === 'true' &&
            String(item.properties?._reward_tier) === '4' &&
            Number(item.quantity) === 1 &&
            Number(item.final_line_price) === 0
        );
      }

      async reconcile(cart) {
        if (this.reconciling) return;

        const qualified = this.qualifyingQuantity(cart) >= Number(this.dataset.threshold);
        const gifts = this.giftItems(cart);
        const alreadyCorrect = qualified && gifts.length === 1 && this.isValidGift(gifts[0]);
        const alreadyAbsent = !qualified && gifts.length === 0;

        if (alreadyCorrect || alreadyAbsent) {
          window.TBHNPCartRewards?.setCheckoutBlocked(this.checkoutOwner, false);
          return;
        }

        window.TBHNPCartRewards?.setCheckoutBlocked(this.checkoutOwner, true);
        this.reconciling = true;
        const reconcileGift = async () => {
          const currentCart = window.TBHNPCartRewards
            ? await window.TBHNPCartRewards.get(true)
            : await this.fetchCart();
          const currentQualified =
            this.qualifyingQuantity(currentCart) >= Number(this.dataset.threshold);
          const currentGifts = this.giftItems(currentCart);
          const currentCorrect =
            currentQualified && currentGifts.length === 1 && this.isValidGift(currentGifts[0]);
          const currentAbsent = !currentQualified && currentGifts.length === 0;
          if (currentCorrect || currentAbsent) return currentCart;

          let nextCart = currentCart;
          if (currentGifts.length) {
            nextCart = await this.removeGifts(currentGifts, !currentQualified);
          }
          if (currentQualified) nextCart = await this.addGift();
          return nextCart;
        };

        try {
          const nextCart = window.TBHNPCartRewards
            ? await window.TBHNPCartRewards.enqueue(reconcileGift)
            : await reconcileGift();
          const nextGifts = nextCart ? this.giftItems(nextCart) : [];
          const nextQualified = Boolean(
            nextCart && this.qualifyingQuantity(nextCart) >= Number(this.dataset.threshold)
          );
          const settled = nextQualified
            ? nextGifts.length === 1 && this.isValidGift(nextGifts[0])
            : nextGifts.length === 0;
          window.TBHNPCartRewards?.setCheckoutBlocked(this.checkoutOwner, !settled);
        } catch (error) {
          console.error('Unable to update the Mystery Gift reward', error);
        } finally {
          this.reconciling = false;
        }
      }

      sectionIds() {
        return Array.from(document.querySelectorAll('cart-items-component[data-section-id]'))
          .map((element) => element.dataset.sectionId)
          .filter(Boolean);
      }

      cartUrl(action) {
        return `${window.Shopify?.routes?.root || '/'}cart/${action}.js`;
      }

      async requestJSON(url, options = {}) {
        const response = await fetch(url, {credentials: 'same-origin', ...options});
        const responseText = await response.text();
        let result;

        try {
          result = JSON.parse(responseText);
        } catch (error) {
          throw new Error(`Mystery Gift cart response was not valid JSON (${response.status})`);
        }

        if (!response.ok || !result || typeof result !== 'object' || result.status || result.errors) {
          throw new Error(result?.description || result?.message || 'Mystery Gift cart request failed');
        }
        return result;
      }

      async fetchCart() {
        const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart.js`, {
          credentials: 'same-origin',
          headers: {Accept: 'application/json'}
        });
        if (!response.ok) throw new Error('Unable to refresh cart');
        return response.json();
      }

      async addGift() {
        const result = await this.requestJSON(this.cartUrl('add'), {
          method: 'POST',
          headers: {'Content-Type': 'application/json', Accept: 'application/json'},
          body: JSON.stringify({
            items: [
              {
                id: this.dataset.variantId,
                quantity: 1,
                properties: {
                  _mystery_gift_reward: 'true',
                  _reward_tier: '4'
                }
              }
            ],
            sections: this.sectionIds().join(','),
            sections_url: window.location.pathname
          })
        });
        const cart = window.TBHNPCartRewards
          ? await window.TBHNPCartRewards.get(true)
          : await this.fetchCart();
        this.dispatchUpdate(cart, result.sections || {});
        return cart;
      }

      async removeGifts(gifts, shouldDispatch = true) {
        const updates = {};
        gifts.forEach((item) => {
          updates[item.key] = 0;
        });
        const result = await this.requestJSON(this.cartUrl('update'), {
          method: 'POST',
          headers: {'Content-Type': 'application/json', Accept: 'application/json'},
          body: JSON.stringify({
            updates,
            sections: this.sectionIds().join(','),
            sections_url: window.location.pathname
          })
        });
        if (shouldDispatch) this.dispatchUpdate(result, result.sections || {});
        return result;
      }

      dispatchUpdate(cart, sections) {
        window.TBHNPCartRewards?.set(cart);
        document.dispatchEvent(
          new CustomEvent('cart:update', {
            bubbles: true,
            detail: {
              resource: cart,
              data: {source: 'mystery-gift-manager', sections}
            }
          })
        );
      }
    }

    customElements.define('mystery-gift-manager', MysteryGiftManager);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["tbhnp-cart-delivery"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('tbhnp-cart-delivery')) {
    class TBHNPCartDelivery extends HTMLElement {
      connectedCallback() {
        const scope = this.closest('cart-items-component');
        this.rewardBar = scope?.querySelector('cart-reward-bar') || document.querySelector('cart-reward-bar');
        this.observer = new MutationObserver(() => this.renderQuantity(this.rewardBar?.dataset.quantity));
        if (this.rewardBar) this.observer.observe(this.rewardBar, { attributes: true, attributeFilter: ['data-quantity'] });
        this.onCartUpdate = (event) => {
          const cart = event.detail?.resource || event.detail?.cart;
          const rewards = window.TBHNPCartRewards;
          if (rewards?.isFullCart?.(cart)) this.renderQuantity(rewards.qualifyingQuantity(cart));
        };
        document.addEventListener('cart:update', this.onCartUpdate);
      }
      disconnectedCallback() {
        this.observer?.disconnect();
        document.removeEventListener('cart:update', this.onCartUpdate);
      }
      renderQuantity(quantity) {
        if (quantity == null || !Number.isFinite(Number(quantity)) || this.dataset.supported !== 'true') return;
        const price = this.querySelector('[data-delivery-price]');
        if (price) price.textContent = Number(quantity) >= 2 ? this.dataset.free : this.dataset.paid;
      }
    }
    customElements.define('tbhnp-cart-delivery', TBHNPCartDelivery);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["tbhnp-mobile-global-header"] && !Shopify.designMode) return;
  try {
    (() => {
    const elementName = 'tbhnp-mobile-global-header';

    if (customElements.get(elementName)) return;

    class TBHNPMobileGlobalHeader extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.lifecycle = new AbortController();
        this.mobileMedia = window.matchMedia(
          '(max-width: 1179px), (orientation: landscape) and (max-height: 520px)'
        );
        this.hoverPointer = window.matchMedia('(hover: hover) and (pointer: fine)');
        this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.utilityMenu = this.querySelector('[data-utility-menu]');
        this.menuToggle = this.querySelector('[data-menu-toggle]');
        this.menuGlyph = this.querySelector('[data-menu-glyph]');
        this.categoryPanel = this.querySelector('[data-category-panel]');
        this.categoryCapsule = this.querySelector('[data-category-capsule]');
        this.categoryLabel = this.querySelector('[data-category-label]');
        this.menuStatus = this.querySelector('[data-menu-status]');
        this.categoryLinks = [
          ...this.querySelectorAll('.tbhnp-mobile-global-header__category-link')
        ];
        this.cartToggle = this.querySelector('[data-cart-toggle]');
        this.cartCount = this.querySelector('[data-cart-count]');
        this.searchToggle = this.querySelector('[data-search-toggle]');
        this.submenuToggles = [
          ...this.querySelectorAll('[data-submenu-toggle]')
        ];
        this.submenuPanels = [
          ...this.querySelectorAll('[data-submenu-panel]')
        ];
        this.submenuCloseButtons = [
          ...this.querySelectorAll('[data-submenu-close]')
        ];
        this.aboutLinks = this.querySelector('[data-about-links]');
        this.subscribeView = this.querySelector('[data-subscribe-view]');
        this.subscribeToggle = this.querySelector('[data-subscribe-toggle]');
        this.subscribeBack = this.querySelector('[data-subscribe-back]');
        this.localizationForm = this.querySelector(
          '.tbhnp-mobile-global-header__localization-form'
        );
        this.localizationLanguageInput = this.querySelector(
          '[data-localization-language-input]'
        );
        this.localizationCountryInput = this.querySelector(
          '[data-localization-country-input]'
        );
        this.localizationLiveValue = this.querySelector(
          '[data-localization-live-value]'
        );
        this.localizationTriggerValue = this.querySelector(
          '[data-localization-trigger-value]'
        );
        this.localizationLanguageOptions = [
          ...this.querySelectorAll('[data-language-code]')
        ];
        this.isMenuOpen = false;
        this.activeSubmenuName = '';
        this.menuTurn = 0;
        this.categoryLabelFrame = 0;
        this.categoryLabelTimer = 0;
        this.currentCategoryLink = this.findActiveCategoryLink();
        this.previewCategoryLink = this.currentCategoryLink;
        this.armedCategoryLink = null;
        this.scrubPointerId = null;
        this.scrubCategoryLink = null;
        this.suppressCategoryClickUntil = 0;

        this.syncClosedDom();
        this.bindEvents();
        if (this.previewCategoryLink) {
          this.setPreviewCategoryLink(this.previewCategoryLink, false);
        } else {
          this.clearCategoryPreview();
        }
        this.syncCartCount();

        if (this.querySelector('[data-subscribe-result]')) {
          window.requestAnimationFrame(() => {
            this.setMenuOpen(true);
            this.setSubmenuOpen('about-us');
            this.showSubscribeView();
          });
        }
      }

      disconnectedCallback() {
        this.syncClosedDom();
        this.lifecycle?.abort();
        window.cancelAnimationFrame(this.categoryLabelFrame);
        window.clearTimeout(this.categoryLabelTimer);
        this.initialized = false;
      }

      syncClosedDom() {
        this.isMenuOpen = false;
        this.menuTurn = 0;
        document.documentElement.removeAttribute('data-tbhnp-menu-open');
        this.utilityMenu?.classList.remove('is-open');
        this.menuGlyph?.style.setProperty('--tbhnp-menu-turn', '0deg');
        this.menuToggle?.setAttribute('aria-expanded', 'false');
        this.menuToggle?.setAttribute(
          'aria-label',
          this.dataset.openMenuLabel || 'Open menu'
        );
        this.categoryCapsule?.classList.remove('is-scrubbing');
        this.scrubPointerId = null;
        this.scrubCategoryLink = null;
        this.armedCategoryLink = null;
        this.suppressCategoryClickUntil = 0;
        this.categoryPanel?.setAttribute('aria-hidden', 'true');
        this.categoryPanel?.setAttribute('inert', '');
        this.categoryLabel?.classList.remove('is-visible');
        this.closeSubmenu(false);
      }

      findActiveCategoryLink() {
        const currentUrl = new URL(window.location.href);
        const currentPath = currentUrl.pathname.replace(/\/+$/, '') || '/';
        const pathMatches = (link) => {
          if (link.tagName !== 'A' || !link.href) return false;
          const linkUrl = new URL(link.href, window.location.origin);
          const linkPath = linkUrl.pathname.replace(/\/+$/, '') || '/';
          if (linkPath !== currentPath) return false;

          return [...linkUrl.searchParams].every(
            ([key, value]) => currentUrl.searchParams.get(key) === value
          );
        };
        const directMatch = this.categoryLinks.find((link) => {
          if (link.dataset.npcNavTrigger !== undefined) return false;
          return pathMatches(link);
        });

        if (directMatch) return directMatch;

        const submenuLinks = [
          ...this.querySelectorAll('[data-submenu-panel] a[href]')
        ];
        submenuLinks.forEach((link) => link.removeAttribute('aria-current'));
        const matchingSubmenuLink = submenuLinks.find(pathMatches);

        if (!matchingSubmenuLink) return null;

        matchingSubmenuLink.setAttribute('aria-current', 'page');
        const matchingPanel = matchingSubmenuLink.closest(
          '[data-submenu-panel]'
        );

        return (
          this.submenuToggles.find(
            (toggle) =>
              toggle.dataset.submenuToggle === matchingPanel?.dataset.submenuPanel
          ) || null
        );
      }

      positionCategoryLabel() {
        this.categoryLabelFrame = 0;

        if (
          !this.previewCategoryLink ||
          !this.isMenuOpen ||
          !this.categoryLabel ||
          !this.categoryPanel ||
          !this.categoryCapsule
        ) {
          this.categoryLabel?.classList.remove('is-visible');
          return;
        }

        this.categoryLabel.textContent =
          this.previewCategoryLink.dataset.category.toUpperCase();
        const linkBounds = this.previewCategoryLink.getBoundingClientRect();
        const panelBounds = this.categoryPanel.getBoundingClientRect();
        const capsuleBounds = this.categoryCapsule.getBoundingClientRect();
        const isFullyVisible =
          linkBounds.top >= capsuleBounds.top + 4 &&
          linkBounds.bottom <= capsuleBounds.bottom - 4;

        this.categoryLabel.style.top = `${linkBounds.top - panelBounds.top + 7}px`;
        this.categoryLabel.classList.toggle('is-visible', isFullyVisible);
      }

      scheduleCategoryLabel() {
        window.cancelAnimationFrame(this.categoryLabelFrame);
        this.categoryLabelFrame = window.requestAnimationFrame(() => {
          this.positionCategoryLabel();
        });
      }

      setPreviewCategoryLink(
        nextLink,
        announce = true,
        ensureVisible = true
      ) {
        if (!nextLink) return;

        this.categoryLinks.forEach((link) => {
          link.classList.toggle('is-active', link === nextLink);

          if (link.tagName === 'A') {
            if (link === this.currentCategoryLink) {
              link.setAttribute('aria-current', 'page');
            } else {
              link.removeAttribute('aria-current');
            }
          }
        });
        this.previewCategoryLink = nextLink;

        if (announce && this.menuStatus) {
          const prefix = this.dataset.navigationPrefix || 'Navigation';
          this.menuStatus.textContent =
            `${prefix}: ${nextLink.dataset.category}`;
        }

        if (
          ensureVisible &&
          this.isMenuOpen &&
          this.categoryCapsule &&
          this.categoryPanel
        ) {
          const linkBounds = nextLink.getBoundingClientRect();
          const capsuleBounds = this.categoryCapsule.getBoundingClientRect();
          const isFullyVisible =
            linkBounds.top >= capsuleBounds.top + 4 &&
            linkBounds.bottom <= capsuleBounds.bottom - 4;

          if (!isFullyVisible) {
            nextLink.scrollIntoView({
              block: 'nearest',
              inline: 'nearest',
              behavior: this.reducedMotion.matches ? 'auto' : 'smooth'
            });
          }
        }

        this.scheduleCategoryLabel();
      }

      clearCategoryPreview() {
        this.armedCategoryLink = null;
        this.previewCategoryLink = null;
        this.categoryLinks.forEach((link) => {
          link.classList.remove('is-active');
        });
        if (this.categoryLabel) {
          this.categoryLabel.textContent = '';
          this.categoryLabel.classList.remove('is-visible');
        }
      }

      resetCategoryPreview() {
        this.armedCategoryLink = null;
        if (this.currentCategoryLink) {
          this.setPreviewCategoryLink(this.currentCategoryLink, false);
        } else {
          this.clearCategoryPreview();
        }
      }

      showAboutLinks() {
        if (this.aboutLinks) this.aboutLinks.hidden = false;
        if (this.subscribeView) this.subscribeView.hidden = true;
      }

      showSubscribeView() {
        if (this.aboutLinks) this.aboutLinks.hidden = true;
        if (this.subscribeView) this.subscribeView.hidden = false;
        window.requestAnimationFrame(() => {
          this.querySelector('[data-subscribe-email]')?.focus();
        });
      }

      updateLocalizationValue() {
        const selectedLanguage = this.localizationLanguageOptions.find(
          (option) => option.getAttribute('aria-pressed') === 'true'
        );
        const selectedCountry = this.localizationCountryInput?.selectedOptions?.[0];
        const languageLabel =
          selectedLanguage?.dataset.languageLabel ||
          this.localizationLanguageInput?.value?.toUpperCase() ||
          '';
        const currencyLabel =
          selectedCountry?.dataset.currencyCode ||
          this.localizationCountryInput?.dataset.currencyCode ||
          '';
        const value = [languageLabel, currencyLabel].filter(Boolean).join(' · ');

        if (value && this.localizationLiveValue) {
          this.localizationLiveValue.textContent = value;
        }
        if (value && this.localizationTriggerValue) {
          this.localizationTriggerValue.textContent = value;
        }
      }

      selectLocalizationLanguage(option) {
        if (!option || !this.localizationLanguageInput) return;

        this.localizationLanguageOptions.forEach((item) => {
          item.setAttribute('aria-pressed', String(item === option));
        });
        this.localizationLanguageInput.value = option.dataset.languageCode;
        this.updateLocalizationValue();
      }

      positionSubmenuPanel(toggle, panel) {
        if (!toggle || !panel || !this.utilityMenu) return;

        const utilityBounds = this.utilityMenu.getBoundingClientRect();
        const toggleBounds = toggle.getBoundingClientRect();
        const viewportHeight = window.visualViewport?.height || window.innerHeight;
        const viewportWidth = window.visualViewport?.width || window.innerWidth;
        const isCatalogSubmenu = panel.hasAttribute('data-catalog-submenu');

        if (this.mobileMedia.matches) {
          if (isCatalogSubmenu) {
            const isNarrowViewport = viewportWidth <= 359;
            const railWidth =
              this.categoryPanel?.getBoundingClientRect().width || 198;
            const submenuLeft = isNarrowViewport ? 0 : railWidth + 8;
            const availableWidth = Math.max(
              0,
              viewportWidth - utilityBounds.left - submenuLeft - 10
            );
            const submenuWidth = isNarrowViewport
              ? Math.max(0, viewportWidth - utilityBounds.left * 2)
              : Math.min(188, availableWidth);

            panel.style.setProperty(
              '--tbhnp-catalog-submenu-width',
              `${submenuWidth}px`
            );

            const panelBounds = panel.getBoundingClientRect();
            const minimumTop = Math.max(utilityBounds.top + 58, 8);
            const maximumTop = Math.max(
              minimumTop,
              viewportHeight - panelBounds.height - 12
            );
            const desiredTop = isNarrowViewport
              ? minimumTop
              : toggleBounds.top;
            const viewportTop = Math.min(
              maximumTop,
              Math.max(minimumTop, desiredTop)
            );

            panel.style.setProperty(
              '--tbhnp-submenu-top',
              `${viewportTop - utilityBounds.top}px`
            );
            panel.style.setProperty(
              '--tbhnp-submenu-left',
              `${submenuLeft}px`
            );
            panel.style.setProperty(
              '--tbhnp-submenu-viewport-top',
              `${viewportTop}px`
            );
            return;
          }

          const panelBounds = panel.getBoundingClientRect();
          const minimumTop = Math.max(utilityBounds.top + 58, 8);
          const maximumTop = Math.max(
            minimumTop,
            viewportHeight - panelBounds.height - 12
          );
          const desiredTop =
            toggleBounds.top + toggleBounds.height / 2 - panelBounds.height / 2;
          const viewportTop = Math.min(
            maximumTop,
            Math.max(minimumTop, desiredTop)
          );

          panel.style.setProperty(
            '--tbhnp-submenu-top',
            `${viewportTop - utilityBounds.top}px`
          );
          panel.style.setProperty('--tbhnp-submenu-left', '60px');
          panel.style.setProperty(
            '--tbhnp-submenu-viewport-top',
            `${viewportTop}px`
          );
          return;
        }

        if (isCatalogSubmenu) {
          const categoryBounds = this.categoryPanel?.getBoundingClientRect();
          const desiredLeft = Math.max(
            0,
            toggleBounds.left - utilityBounds.left
          );
          const availableWidth = Math.max(
            0,
            viewportWidth - utilityBounds.left - desiredLeft - 16
          );
          const preferredWidth =
            panel.dataset.submenuPanel === 'bottoms' ? 620 : 1020;
          const submenuWidth = Math.min(preferredWidth, availableWidth);
          const submenuTop =
            (categoryBounds?.bottom || utilityBounds.top + 124) -
            utilityBounds.top +
            12;

          panel.style.setProperty(
            '--tbhnp-catalog-submenu-width',
            `${submenuWidth}px`
          );
          panel.style.setProperty('--tbhnp-submenu-top', `${submenuTop}px`);
          panel.style.setProperty(
            '--tbhnp-submenu-left',
            `${desiredLeft}px`
          );
          panel.style.setProperty(
            '--tbhnp-submenu-viewport-top',
            `${utilityBounds.top + submenuTop}px`
          );
          return;
        }

        const panelBounds = panel.getBoundingClientRect();
        const desiredLeft = toggleBounds.left - utilityBounds.left;
        const maximumLeft = Math.max(
          0,
          viewportWidth - utilityBounds.left - panelBounds.width - 16
        );

        panel.style.setProperty('--tbhnp-submenu-top', '124px');
        panel.style.setProperty(
          '--tbhnp-submenu-left',
          `${Math.min(maximumLeft, Math.max(0, desiredLeft))}px`
        );
        panel.style.setProperty(
          '--tbhnp-submenu-viewport-top',
          `${utilityBounds.top + 124}px`
        );
      }

      closeSubmenu(resetPreview = true) {
        this.submenuToggles.forEach((toggle) => {
          toggle.setAttribute('aria-expanded', 'false');
        });
        this.submenuPanels.forEach((panel) => {
          panel.classList.remove('is-open');
          panel.setAttribute('aria-hidden', 'true');
          panel.setAttribute('inert', '');
        });
        this.activeSubmenuName = '';
        this.showAboutLinks();

        if (resetPreview && this.isMenuOpen) this.resetCategoryPreview();
      }

      setSubmenuOpen(name) {
        const toggle = this.submenuToggles.find(
          (item) => item.dataset.submenuToggle === name
        );
        const panel = this.submenuPanels.find(
          (item) => item.dataset.submenuPanel === name
        );

        if (!toggle || !panel) return;

        const shouldOpen = this.activeSubmenuName !== name;
        this.closeSubmenu(false);

        if (!shouldOpen) {
          this.resetCategoryPreview();
          return;
        }

        this.activeSubmenuName = name;
        toggle.setAttribute('aria-expanded', 'true');
        panel.classList.add('is-open');
        panel.setAttribute('aria-hidden', 'false');
        panel.removeAttribute('inert');
        this.setPreviewCategoryLink(toggle);
        this.positionSubmenuPanel(toggle, panel);
        window.requestAnimationFrame(() => {
          this.positionSubmenuPanel(toggle, panel);
        });
      }

      prepareCollectionNavigation(link) {
        if (link?.tagName !== 'A' || !link.href) return false;

        const targetUrl = new URL(link.href, window.location.href);
        if (
          targetUrl.origin !== window.location.origin ||
          !targetUrl.pathname.includes('/collections/')
        ) {
          return false;
        }

        const detail = {
          path: `${targetUrl.pathname}${targetUrl.search}`,
          createdAt: Date.now()
        };

        try {
          window.sessionStorage.setItem(
            'tbhnp-fast-collection-navigation:v1',
            JSON.stringify(detail)
          );
        } catch (error) {
          // Navigation remains functional when session storage is unavailable.
        }

        document.dispatchEvent(
          new CustomEvent('tbhnp:collection-navigation-start', { detail })
        );
        return true;
      }

      handleCollectionNavigationIntent(event) {
        if (
          event.defaultPrevented ||
          event.button !== 0 ||
          event.metaKey ||
          event.ctrlKey ||
          event.shiftKey ||
          event.altKey
        ) {
          return;
        }

        const link = event.target.closest('a[href]');
        if (
          !link ||
          (link.target && link.target.toLowerCase() !== '_self') ||
          link.hasAttribute('download')
        ) {
          return;
        }

        const lifecycleSignal = this.lifecycle?.signal;
        let navigationFinalized = false;
        let navigationFallbackTimer = 0;
        const finalizeNavigation = () => {
          if (navigationFinalized) return;
          navigationFinalized = true;
          window.clearTimeout(navigationFallbackTimer);
          window.removeEventListener('click', finalizeOnWindow);

          if (
            event.defaultPrevented ||
            link.isConnected === false ||
            lifecycleSignal?.aborted
          ) {
            return;
          }

          this.prepareCollectionNavigation(link);
        };
        const finalizeOnWindow = (bubbledEvent) => {
          if (bubbledEvent !== event) return;
          finalizeNavigation();
        };

        window.addEventListener('click', finalizeOnWindow, {
          once: true,
          signal: lifecycleSignal
        });
        navigationFallbackTimer = window.setTimeout(finalizeNavigation, 0);
      }

      activateCategoryLink(nextLink) {
        if (!nextLink) return;

        this.setPreviewCategoryLink(nextLink);

        if (!nextLink.dataset.submenuToggle) this.closeSubmenu(false);

        if (nextLink === this.searchToggle) {
          this.openSearch();
          return;
        }

        if (nextLink.dataset.submenuToggle) {
          this.setSubmenuOpen(nextLink.dataset.submenuToggle);
          return;
        }

        if (nextLink.dataset.npcNavTrigger !== undefined) {
          document.dispatchEvent(
            new CustomEvent('tbhnp:npc-open', {
              detail: { trigger: nextLink }
            })
          );
          this.setMenuOpen(false);
          return;
        }

        if (nextLink.tagName === 'A' && nextLink.href) {
          this.prepareCollectionNavigation(nextLink);
          window.location.assign(nextLink.href);
        }
      }

      handleCategoryClick(event) {
        const nextLink = event.target.closest(
          '.tbhnp-mobile-global-header__category-link'
        );

        if (!nextLink) return;

        if (event.defaultPrevented) return;

        if (
          nextLink.tagName === 'A' &&
          (event.button !== 0 ||
            event.metaKey ||
            event.ctrlKey ||
            event.shiftKey ||
            event.altKey)
        ) {
          return;
        }

        if (window.performance.now() < this.suppressCategoryClickUntil) {
          event.preventDefault();
          return;
        }

        this.armedCategoryLink = null;

        const isNativeAnchor =
          nextLink.tagName === 'A' &&
          Boolean(nextLink.href) &&
          nextLink !== this.searchToggle &&
          nextLink.dataset.submenuToggle === undefined &&
          nextLink.dataset.npcNavTrigger === undefined;

        if (isNativeAnchor) {
          this.setPreviewCategoryLink(nextLink);
          this.closeSubmenu(false);
          return;
        }

        this.activateCategoryLink(nextLink);
      }

      syncCategoryOverflow() {
        if (!this.categoryCapsule) return;

        const isOverflowing =
          this.categoryCapsule.scrollHeight >
          this.categoryCapsule.clientHeight + 1;
        this.categoryCapsule.classList.toggle('is-overflowing', isOverflowing);
      }

      isMobileScrubEvent(event) {
        return (
          this.mobileMedia.matches &&
          this.isMenuOpen &&
          !this.categoryCapsule?.classList.contains('is-overflowing') &&
          event.isPrimary &&
          (event.pointerType === 'touch' || event.pointerType === 'pen')
        );
      }

      findScrubCategoryLink(clientX, clientY) {
        const directLink = document
          .elementFromPoint(clientX, clientY)
          ?.closest('.tbhnp-mobile-global-header__category-link');

        if (directLink && this.categoryCapsule?.contains(directLink)) {
          return directLink;
        }

        let nearestLink = null;
        let nearestDistance = Number.POSITIVE_INFINITY;

        this.categoryLinks.forEach((link) => {
          const bounds = link.getBoundingClientRect();
          const centerY = bounds.top + bounds.height / 2;
          const distance = Math.abs(clientY - centerY);

          if (distance < nearestDistance) {
            nearestDistance = distance;
            nearestLink = link;
          }
        });

        return nearestDistance <= 32 ? nearestLink : null;
      }

      beginCategoryScrub(event) {
        if (!this.isMobileScrubEvent(event)) return;

        const nextLink = this.findScrubCategoryLink(
          event.clientX,
          event.clientY
        );

        if (!nextLink) return;

        event.preventDefault();
        this.scrubPointerId = event.pointerId;
        this.scrubCategoryLink = nextLink;
        this.categoryCapsule?.classList.add('is-scrubbing');
        this.categoryPanel?.setPointerCapture?.(event.pointerId);
        this.setPreviewCategoryLink(nextLink);
      }

      moveCategoryScrub(event) {
        if (event.pointerId !== this.scrubPointerId) return;

        event.preventDefault();
        const nextLink = this.findScrubCategoryLink(
          event.clientX,
          event.clientY
        );

        if (!nextLink || nextLink === this.scrubCategoryLink) return;

        this.scrubCategoryLink = nextLink;
        this.setPreviewCategoryLink(nextLink);
      }

      finishCategoryScrub(event, shouldActivate = true) {
        if (event.pointerId !== this.scrubPointerId) return;

        event.preventDefault();
        const nextLink =
          this.findScrubCategoryLink(event.clientX, event.clientY) ||
          this.scrubCategoryLink;

        if (this.categoryPanel?.hasPointerCapture?.(event.pointerId)) {
          this.categoryPanel.releasePointerCapture(event.pointerId);
        }

        this.categoryCapsule?.classList.remove('is-scrubbing');
        this.scrubPointerId = null;
        this.scrubCategoryLink = null;
        this.suppressCategoryClickUntil = window.performance.now() + 500;

        if (!shouldActivate || !nextLink) {
          this.resetCategoryPreview();
          return;
        }

        this.activateCategoryLink(nextLink);
      }

      setMenuOpen(nextOpen, returnFocus = false) {
        if (
          !this.utilityMenu ||
          !this.menuToggle ||
          !this.menuGlyph ||
          !this.categoryPanel
        ) {
          this.isMenuOpen = false;
          return;
        }

        if (nextOpen === this.isMenuOpen) return;

        const activeElement = document.activeElement;
        const focusWasInsideMenu =
          !nextOpen &&
          (this.categoryPanel.contains(activeElement) ||
            this.submenuPanels.some((panel) => panel.contains(activeElement)));

        this.isMenuOpen = nextOpen;
        document.documentElement.toggleAttribute('data-tbhnp-menu-open', nextOpen);
        this.utilityMenu.classList.toggle('is-open', nextOpen);
        this.menuToggle.setAttribute('aria-expanded', String(nextOpen));
        this.menuToggle.setAttribute(
          'aria-label',
          nextOpen
            ? this.dataset.closeMenuLabel || 'Close menu'
            : this.dataset.openMenuLabel || 'Open menu'
        );
        this.categoryPanel.setAttribute('aria-hidden', String(!nextOpen));

        if (nextOpen) {
          this.categoryPanel.removeAttribute('inert');
          this.resetCategoryPreview();
          window.requestAnimationFrame(() => this.syncCategoryOverflow());
          this.scheduleCategoryLabel();
          window.clearTimeout(this.categoryLabelTimer);
          this.categoryLabelTimer = window.setTimeout(
            () => this.scheduleCategoryLabel(),
            260
          );
          return;
        }

        window.clearTimeout(this.categoryLabelTimer);
        this.categoryLabelTimer = 0;
        this.categoryLabel?.classList.remove('is-visible');
        this.closeSubmenu(false);
        this.resetCategoryPreview();
        this.categoryPanel.setAttribute('inert', '');

        if (returnFocus || focusWasInsideMenu) this.menuToggle.focus();
      }

      updateCartCount(itemCount) {
        if (!this.cartCount || !this.cartToggle) return;

        const normalizedCount =
          Number.isFinite(itemCount) && itemCount > 0
            ? Math.floor(itemCount)
            : 0;
        const template =
          normalizedCount === 1
            ? this.dataset.openCartTemplateSingle ||
              this.dataset.openCartTemplate ||
              'Open cart, __COUNT__ item'
            : this.dataset.openCartTemplate || 'Open cart, __COUNT__ items';

        this.cartCount.textContent = String(normalizedCount);
        this.cartCount.hidden = normalizedCount === 0;
        this.cartToggle.setAttribute(
          'aria-label',
          template.replace('__COUNT__', String(normalizedCount))
        );
      }

      syncCartCount() {
        const nativeCount = document.querySelector(
          '[data-testid="cart-icon"] .cart-bubble__text-count'
        );
        const value = nativeCount?.textContent.match(/\d+/)?.[0];

        if (value !== undefined) {
          this.updateCartCount(Number.parseInt(value, 10));
        }
      }

      openCart() {
        this.setMenuOpen(false);
        const cartDrawer = document.querySelector('cart-drawer-component');

        if (typeof cartDrawer?.open === 'function') {
          cartDrawer.open();
          return;
        }

        const cartTrigger = document.querySelector(
          '[data-testid="cart-drawer-trigger"]'
        );

        if (cartTrigger) {
          cartTrigger.click();
          return;
        }

        window.location.assign(this.dataset.cartUrl || '/cart');
      }

      async openSearch() {
        const lifecycleSignal = this.lifecycle?.signal;
        this.setMenuOpen(false);
        const searchModal = document.querySelector('#search-modal');

        if (!searchModal) {
          window.location.assign(this.dataset.searchUrl || '/search');
          return;
        }

        if (window.customElements?.whenDefined) {
          await Promise.race([
            window.customElements.whenDefined('dialog-component'),
            new Promise((resolve) => window.setTimeout(resolve, 500))
          ]);
        }

        if (lifecycleSignal?.aborted || !this.isConnected) return;

        if (typeof searchModal.showDialog === 'function') {
          searchModal.showDialog();
          return;
        }

        const nativeDialog = searchModal.querySelector('dialog');

        if (typeof nativeDialog?.showModal === 'function') {
          nativeDialog.showModal();
          return;
        }

        window.location.assign(this.dataset.searchUrl || '/search');
      }

      closeActiveSubmenu(returnFocus = false) {
        const activeName = this.activeSubmenuName;
        if (!activeName) return;

        const toggle = this.submenuToggles.find(
          (item) => item.dataset.submenuToggle === activeName
        );
        this.closeSubmenu(false);

        if (toggle) {
          this.setPreviewCategoryLink(toggle, false);
          if (returnFocus) toggle.focus();
        }
      }

      findFirstSubmenuControl(panel) {
        return panel?.querySelector(
          'a[href], button:not([data-submenu-close]):not([disabled]), input:not([type="hidden"]):not([disabled]), select:not([disabled]), textarea:not([disabled])'
        );
      }

      handleCategoryKeydown(event) {
        const currentIndex = this.categoryLinks.indexOf(
          document.activeElement
        );

        if (currentIndex < 0) return;

        const currentLink = this.categoryLinks[currentIndex];
        const submenuName = currentLink.dataset.submenuToggle;
        const openSubmenuKey =
          event.key === 'ArrowRight' ||
          (!this.mobileMedia.matches && event.key === 'ArrowDown');

        if (submenuName && openSubmenuKey) {
          event.preventDefault();
          if (this.activeSubmenuName !== submenuName) {
            this.setSubmenuOpen(submenuName);
          }
          const panel = this.submenuPanels.find(
            (item) => item.dataset.submenuPanel === submenuName
          );
          this.findFirstSubmenuControl(panel)?.focus();
          return;
        }

        const keyMoves = {
          ArrowDown: (currentIndex + 1) % this.categoryLinks.length,
          ArrowRight: (currentIndex + 1) % this.categoryLinks.length,
          ArrowUp:
            (currentIndex - 1 + this.categoryLinks.length) %
            this.categoryLinks.length,
          ArrowLeft:
            (currentIndex - 1 + this.categoryLinks.length) %
            this.categoryLinks.length,
          Home: 0,
          End: this.categoryLinks.length - 1
        };
        const nextIndex = keyMoves[event.key];

        if (nextIndex === undefined) return;

        event.preventDefault();
        this.categoryLinks[nextIndex].focus();
      }

      handleCatalogSubmenuKeydown(event) {
        const panel = event.currentTarget;
        if (!(panel instanceof HTMLElement)) return;

        if (event.key === 'Escape' || event.key === 'ArrowLeft') {
          event.preventDefault();
          event.stopPropagation();
          this.closeActiveSubmenu(true);
          return;
        }

        const focusableItems = [
          ...panel.querySelectorAll(
            '.tbhnp-mobile-global-header__submenu-list--catalog a[href]'
          )
        ];
        const currentIndex = focusableItems.indexOf(document.activeElement);
        if (currentIndex < 0) return;

        const keyMoves = {
          ArrowDown: (currentIndex + 1) % focusableItems.length,
          ArrowRight: (currentIndex + 1) % focusableItems.length,
          ArrowUp:
            (currentIndex - 1 + focusableItems.length) %
            focusableItems.length,
          Home: 0,
          End: focusableItems.length - 1
        };
        const nextIndex = keyMoves[event.key];
        if (nextIndex === undefined) return;

        event.preventDefault();
        focusableItems[nextIndex].focus();
      }

      bindEvents() {
        const { signal } = this.lifecycle;

        this.addEventListener(
          'click',
          (event) => this.handleCollectionNavigationIntent(event),
          { signal }
        );

        this.menuToggle?.addEventListener(
          'click',
          () => this.setMenuOpen(!this.isMenuOpen),
          { signal }
        );

        this.categoryPanel?.addEventListener(
          'pointerdown',
          (event) => this.beginCategoryScrub(event),
          { signal }
        );

        this.categoryPanel?.addEventListener(
          'pointermove',
          (event) => this.moveCategoryScrub(event),
          { signal }
        );

        this.categoryPanel?.addEventListener(
          'pointerup',
          (event) => this.finishCategoryScrub(event),
          { signal }
        );

        this.categoryPanel?.addEventListener(
          'pointercancel',
          (event) => this.finishCategoryScrub(event, false),
          { signal }
        );

        this.categoryPanel?.addEventListener(
          'click',
          (event) => this.handleCategoryClick(event),
          { signal }
        );

        this.categoryPanel?.addEventListener(
          'pointerover',
          (event) => {
            if (!this.hoverPointer.matches || event.pointerType !== 'mouse') return;

            const nextLink = event.target.closest(
              '.tbhnp-mobile-global-header__category-link'
            );
            if (nextLink) this.setPreviewCategoryLink(nextLink, false, false);
          },
          { signal }
        );

        this.categoryPanel?.addEventListener(
          'pointerout',
          (event) => {
            if (!this.hoverPointer.matches || event.pointerType !== 'mouse') return;

            const currentLink = event.target.closest(
              '.tbhnp-mobile-global-header__category-link'
            );
            if (!currentLink || currentLink.contains(event.relatedTarget)) return;

            const nextLink =
              this.submenuToggles.find(
                (toggle) => toggle.dataset.submenuToggle === this.activeSubmenuName
              ) ||
                this.armedCategoryLink ||
                this.currentCategoryLink;

            if (nextLink) {
              this.setPreviewCategoryLink(nextLink, false, false);
            } else {
              this.clearCategoryPreview();
            }
          },
          { signal }
        );

        this.categoryPanel?.addEventListener(
          'focusin',
          (event) => {
            const nextLink = event.target.closest(
              '.tbhnp-mobile-global-header__category-link'
            );
            if (nextLink) this.setPreviewCategoryLink(nextLink, false);
          },
          { signal }
        );

        this.categoryPanel?.addEventListener(
          'keydown',
          (event) => this.handleCategoryKeydown(event),
          { signal }
        );

        this.submenuCloseButtons.forEach((button) => {
          button.addEventListener(
            'click',
            () => this.closeActiveSubmenu(true),
            { signal }
          );
        });

        this.submenuPanels
          .filter((panel) => panel.hasAttribute('data-catalog-submenu'))
          .forEach((panel) => {
            panel.addEventListener(
              'keydown',
              (event) => this.handleCatalogSubmenuKeydown(event),
              { signal }
            );
          });

        this.categoryCapsule?.addEventListener(
          'scroll',
          () => {
            this.scheduleCategoryLabel();
            const toggle = this.submenuToggles.find(
              (item) => item.dataset.submenuToggle === this.activeSubmenuName
            );
            const panel = this.submenuPanels.find(
              (item) => item.dataset.submenuPanel === this.activeSubmenuName
            );
            if (toggle && panel) this.positionSubmenuPanel(toggle, panel);
          },
          { passive: true, signal }
        );

        this.subscribeToggle?.addEventListener(
          'click',
          () => this.showSubscribeView(),
          { signal }
        );

        this.subscribeBack?.addEventListener(
          'click',
          () => this.showAboutLinks(),
          { signal }
        );

        this.localizationLanguageOptions.forEach((option) => {
          option.addEventListener(
            'click',
            () => this.selectLocalizationLanguage(option),
            { signal }
          );
        });

        this.localizationCountryInput?.addEventListener(
          'change',
          () => this.updateLocalizationValue(),
          { signal }
        );

        this.cartToggle?.addEventListener(
          'click',
          () => this.openCart(),
          { signal }
        );

        document.addEventListener(
          'pointerdown',
          (event) => {
            if (this.isMenuOpen && !this.contains(event.target)) {
              this.setMenuOpen(false);
            }
          },
          { signal }
        );

        document.addEventListener(
          'scroll',
          (event) => {
            if (event.target instanceof Node && this.contains(event.target)) {
              return;
            }

            if (this.isMenuOpen) this.setMenuOpen(false);
          },
          { capture: true, passive: true, signal }
        );

        document.addEventListener(
          'keydown',
          (event) => {
            if (event.key !== 'Escape' || !this.isMenuOpen) return;

            event.preventDefault();
            if (this.activeSubmenuName) {
              this.closeActiveSubmenu(true);
              return;
            }
            this.setMenuOpen(false, true);
          },
          { signal }
        );

        document.addEventListener(
          'cart:update',
          (event) => {
            const itemCount = Number(
              event.detail?.data?.itemCount ??
                event.detail?.resource?.item_count ??
                0
            );
            this.updateCartCount(itemCount);
          },
          { signal }
        );

        window.addEventListener(
          'pageshow',
          () => {
            this.currentCategoryLink = this.findActiveCategoryLink();
            this.resetCategoryPreview();
            this.syncCartCount();
          },
          { signal }
        );

        window.addEventListener(
          'resize',
          () => {
            this.syncCategoryOverflow();
            const toggle = this.submenuToggles.find(
              (item) => item.dataset.submenuToggle === this.activeSubmenuName
            );
            const panel = this.submenuPanels.find(
              (item) => item.dataset.submenuPanel === this.activeSubmenuName
            );
            if (toggle && panel) this.positionSubmenuPanel(toggle, panel);
          },
          { passive: true, signal }
        );

        this.mobileMedia.addEventListener(
          'change',
          () => {
            this.setMenuOpen(false);
            this.resetCategoryPreview();
          },
          { signal }
        );
      }
    }

    customElements.define(elementName, TBHNPMobileGlobalHeader);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["tbhnp-mobile-product-slide"] && !Shopify.designMode) return;
  try {
    (() => {
    const elementName = 'tbhnp-mobile-product-slide';
    if (customElements.get(elementName)) return;
  class TbhnpSelectionMotion {
    constructor(group) {
      this.group = group;
      this.lens = document.createElement('i');
      this.lens.className = 'tbhnp-selection-motion__lens';
      this.lens.setAttribute('aria-hidden', 'true');
      this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.onMotionPreference = () => this.update(false);
      this.reduced.addEventListener('change', this.onMotionPreference);
      group.classList.add('tbhnp-selection-motion');
      group.append(this.lens);
      this.resizeObserver = new ResizeObserver(() => this.update(false));
      this.resizeObserver.observe(group);
      this.update(false);
    }
    measure() {
      const button = this.group.querySelector('[data-option-button][aria-checked="true"]');
      if (!button || !button.getClientRects().length || !this.group.offsetWidth) return null;
      const rect = button.getBoundingClientRect();
      const parent = this.group.getBoundingClientRect();
      const sx = parent.width / this.group.offsetWidth || 1;
      const sy = parent.height / this.group.offsetHeight || 1;
      return [(rect.left - parent.left) / sx - this.group.clientLeft, (rect.top - parent.top) / sy - this.group.clientTop, rect.width / sx, rect.height / sy];
    }
    // Read our sampled presentation state, without querying layout during motion.
    currentState() {
      if (!this.animation || !this.samples) return this.rest;
      const frame = Math.max(0, Number(this.animation.currentTime) || 0) / this.stepMs;
      const index = Math.min(Math.floor(frame), this.samples.length - 1);
      const a = this.samples[index];
      const b = this.samples[Math.min(index + 1, this.samples.length - 1)];
      const mix = Math.min(frame - index, 1);
      return {
        p: a.p.map((v, i) => v + (b.p[i] - v) * mix),
        v: a.v.map((v, i) => v + (b.v[i] - v) * mix),
        stretch: a.stretch + (b.stretch - a.stretch) * mix
      };
    }
    update(animate = true) {
      const target = this.measure();
      if (!target || !target[2] || !target[3]) return;
      if (animate && this.target && target.every((v, i) => Math.abs(v - this.target[i]) < .1)) return;
      const from = this.currentState();
      this.stop();
      this.target = target;
      this.rest = { p: [...target], v: [0, 0, 0, 0], stretch: 0 };
      this.base = [target[2], target[3]];
      // Size is written once per selection/layout change. Frames only transform.
      this.lens.style.width = `${this.base[0]}px`;
      this.lens.style.height = `${this.base[1]}px`;
      this.lens.style.transform = this.transform(this.rest);
      this.group.classList.add('is-glass-ready');
      if (!animate || !from || this.reduced.matches || !this.lens.animate) return;
      this.samples = this.spring(from, target);
      this.stepMs = 1000 / 60;
      this.lens.style.willChange = 'transform';
      const animation = this.lens.animate(
        this.samples.map(sample => ({ transform: this.transform(sample) })),
        { duration: (this.samples.length - 1) * this.stepMs, easing: 'linear' }
      );
      this.animation = animation;
      animation.onfinish = () => {
        if (this.animation === animation) this.stop();
      };
    }
    // Calculate the spring once, then let the browser run the transform animation.
    // Retargeting keeps the current position, velocity and stretch.
    spring(from, target) {
      const p = [...from.p];
      const v = [...from.v];
      let stretch = from.stretch;
      const samples = [{ p: [...p], v: [...v], stretch }];
      const dt = 1 / 60;
      const h = dt / 3;
      for (let frame = 0; frame < 90; frame++) {
        for (let step = 0; step < 3; step++) {
          for (let i = 0; i < 4; i++) {
            v[i] += (420 * (target[i] - p[i]) - 39 * v[i]) * h;
            p[i] += v[i] * h;
          }
        }
        stretch += (Math.min(Math.hypot(v[0], v[1]) / 6000, .085) - stretch) * (1 - Math.exp(-18 * dt));
        const moving = p.some((value, i) => Math.abs(value - target[i]) > .12 || Math.abs(v[i]) > .5) || stretch > .002;
        if (!moving || frame === 89) {
          samples.push({ p: [...target], v: [0, 0, 0, 0], stretch: 0 });
          break;
        }
        samples.push({ p: [...p], v: [...v], stretch });
      }
      return samples;
    }
    transform({ p, v, stretch }) {
      const [x, y, width, height] = p;
      const speed = Math.hypot(v[0], v[1]);
      const horizontal = speed > 1 ? Math.abs(v[0]) / speed : 1;
      const sx = 1 + stretch * horizontal - stretch * (1 - horizontal) * .22;
      const sy = 1 + stretch * (1 - horizontal) - stretch * horizontal * .22;
      return `translate3d(${x + width * (1 - sx) / 2}px, ${y + height * (1 - sy) / 2}px, 0) scale(${width * sx / this.base[0]}, ${height * sy / this.base[1]})`;
    }
    stop() {
      if (this.animation) {
        this.animation.onfinish = null;
        this.animation.cancel();
      }
      this.animation = null;
      this.samples = null;
      this.lens.style.willChange = 'auto';
    }
    destroy() {
      this.stop();
      this.resizeObserver.disconnect();
      this.reduced.removeEventListener('change', this.onMotionPreference);
      this.lens.remove();
      this.group.classList.remove('tbhnp-selection-motion', 'is-glass-ready');
    }
  }

    class TBHNPMobileProductSlide extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.mobileMedia = window.matchMedia(
          '(max-width: 749px), (orientation: landscape) and (max-height: 520px)'
        );
        this.desktopMedia = window.matchMedia(
          '(min-width: 750px) and (min-height: 521px)'
        );
        this.sharedTransitionStorageKeys = [
          'tbhnp-shared-product-transition:v2',
          'tbhnp-shared-product-transition:v1'
        ];
        this.sharedTransitionStorageKey = this.sharedTransitionStorageKeys[0];
        this.sharedLifecycle = new AbortController();
        this.sectionElement = this.closest('.shopify-section');
        this.verticalSlides = this.querySelector('[data-vertical-slides]');
        this.detailsScreen = this.querySelector('.tbhnp-mobile-pdp__details-screen');
        this.utilityMenu = this.querySelector('[data-utility-menu]');
        this.menuToggle = this.querySelector('[data-menu-toggle]');
        this.menuGlyph = this.querySelector('[data-menu-glyph]');
        this.categoryPanel = this.querySelector('[data-category-panel]');
        this.categoryCapsule = this.querySelector('[data-category-capsule]');
        this.categoryLabel = this.querySelector('[data-category-label]');
        this.menuStatus = this.querySelector('[data-menu-status]');
        this.categoryLinks = [
          ...this.querySelectorAll('.tbhnp-category-link')
        ];
        this.cartToggle = this.querySelector('[data-cart-toggle]');
        this.cartCount = this.querySelector('[data-cart-count]');
        this.searchToggle = this.querySelector('[data-search-toggle]');
        this.isMenuOpen = false;
        this.activeCategoryLink = this.categoryLinks[0] || null;
        this.menuTurn = 0;
        this.categoryLabelFrame = 0;
        this.viewportFrame = 0;
        this.verticalStackFrame = 0;
        this.sharedHero = this.querySelector('[data-shared-product-hero]');
        this.sharedTransitionState = this.readSharedTransitionState();
        const hasMatchingSharedDestination =
          this.sharedTransitionDestinationMatches(
            this.sharedTransitionState?.href
          );
        this.hasSharedTransitionArrival =
          this.mobileMedia.matches &&
          [1, 2].includes(Number(this.sharedTransitionState?.version)) &&
          this.sharedTransitionState?.direction === 'forward' &&
          this.sharedTransitionState?.productHandle === this.dataset.productHandle &&
          hasMatchingSharedDestination &&
          Date.now() -
            Number(this.sharedTransitionState?.createdAt || 0) <=
            120000;
        if (
          !this.mobileMedia.matches &&
          [1, 2].includes(Number(this.sharedTransitionState?.version))
        ) {
          this.clearSharedTransitionState();
          this.sharedTransitionState = null;
          this.sharedHero?.removeAttribute('data-view-transition-type');
          this.sharedHero?.removeAttribute(
            'data-view-transition-triggered'
          );
          document.documentElement.removeAttribute(
            'data-tbhnp-shared-direction'
          );
        }
        if (this.hasSharedTransitionArrival && !this.reducedMotion.matches) {
          document.documentElement.dataset.tbhnpSharedDirection = 'forward';
        }
        this.hasNativeSharedTransition = false;
        try {
          this.hasNativeSharedTransition =
            this.hasSharedTransitionArrival &&
            this.sharedTransitionState?.nativeViewTransition === true &&
            window.sessionStorage.getItem('custom-transition-type') ===
              'product-image-transition';
        } catch (error) {
          // A missing session store automatically selects the FLIP/fade fallback.
        }
        this.navigationWasLinkActivated = false;
        this.reverseNativeArmed = false;
        this.galleryTrack = this.querySelector('[data-gallery-track]');
        this.mediaSlides = [...this.querySelectorAll('[data-media-slide]')];
        this.mediaPages = [...this.querySelectorAll('[data-media-page]')];
        this.mediaPagination = this.querySelector(
          '.tbhnp-mobile-pdp__media-pagination'
        );
        this.mediaThumbnails = [
          ...this.querySelectorAll('[data-media-thumbnail]')
        ];
        this.desktopZoomImages = [
          ...this.querySelectorAll('[data-desktop-zoom-image]')
        ];
        this.desktopMediaDialog = this.querySelector('[data-desktop-media-dialog]');
        this.desktopDialogViewport = this.querySelector('[data-desktop-dialog-viewport]');
        this.desktopDialogImage = this.querySelector('[data-desktop-dialog-image]');
        this.desktopDialogCount = this.querySelector('[data-desktop-dialog-count]');
        this.desktopZoomOut = this.querySelector('[data-desktop-zoom-out]');
        this.desktopZoomReset = this.querySelector('[data-desktop-zoom-reset]');
        this.desktopZoomIn = this.querySelector('[data-desktop-zoom-in]');
        this.desktopZoomLevel = this.querySelector('[data-desktop-zoom-level]');
        this.optionButtons = [...this.querySelectorAll('[data-option-button]')];
        this.optionLabels = [...this.querySelectorAll('[data-option-value-label]')];
        this.priceElement = this.querySelector('[data-variant-price]');
        this.compareElement = this.querySelector('[data-variant-compare-price]');
        this.saleLabel = this.querySelector('[data-sale-label]');
        this.currentImage = this.querySelector('[data-current-variant-image]');
        this.currentLabel = this.querySelector('[data-current-variant-label]');
        this.addButton = this.querySelector('[data-add-to-cart]');
        this.addLabel = this.querySelector('[data-add-label]');
        this.addPrice = this.querySelector('[data-add-price]');
        this.buySelection = this.querySelector('[data-buy-selection]');
        this.stickyBuy = this.querySelector('.tbhnp-mobile-pdp__sticky-buy');
        this.errorElement = this.querySelector('[data-cart-error]');
        this.liveStatus = this.querySelector('[data-live-status]');
        this.sizeGuideTrigger = this.querySelector('[data-size-guide-toggle]');
        this.sizeGuidePanel = this.querySelector('[data-size-guide-panel]');
        this.sizeGuideDetails = this.sizeGuidePanel?.querySelector(
          '.tbhnp-size-guide__details'
        );
        this.detailsScroll = this.querySelector('[data-details-scroll]');
        this.pullbar = this.querySelector('[data-pullbar]');
        this.pullbarTitle = this.querySelector('.tbhnp-mobile-pdp__title');
        this.pullbarGeometry = null;
        this.pullbarMeasureDirty = true;
        this.pullbarDrag = null;
        this.pullbarClickSuppressed = false;
        this.pullbarObserver = new ResizeObserver(() => {
          this.pullbarMeasureDirty = true;
          this.updateBuyClearance();
          this.scheduleVerticalStack();
        });
        [this.pullbarTitle, this.priceElement, this.detailsScroll, this.stickyBuy].forEach((node) => {
          if (node) this.pullbarObserver.observe(node);
        });
        this.pairTrigger = this.querySelector('[data-pair-trigger]');
        this.pairReveal = this.querySelector('[data-pair-reveal]');
        this.pairCandidates = [
          ...this.querySelectorAll('[data-pair-candidate]')
        ];
        this.pairUserInteracted = false;
        this.pairAutoOpened = false;
        this.pairScrollFrame = 0;
        this.pairObserver = null;
        this.i18n = this.parseJSON('[data-pdp-i18n]', {});
        this.variants = this.parseJSON('[data-product-variants]', []);
        this.variantPrices = this.parseJSON('[data-variant-prices]', {});
        this.colorOptionIndex = Number(this.dataset.colorOptionIndex);
        this.productId = Number(this.dataset.productId);
        this.activeMediaIndex = 0;
        this.galleryPredictedFromIndex = -1;
        this.galleryGestureActive = false;
        this.galleryPointerDown = false;
        this.galleryLastScrollLeft = this.galleryTrack?.scrollLeft || 0;
        this.scrollFrame = 0;
        this.mediaScrollGeneration = 0;
        this.programmaticMediaScroll = null;
        this.programmaticMediaSettleFrame = 0;
        this.programmaticMediaSettleTimer = 0;
        this.mediaThumbnailObserver = null;
        this.mediaThumbnailIdle = 0;
        this.mediaThumbnailTimer = 0;
        this.mediaThumbnailHydrationQueued = false;
        this.mediaThumbnailWaitingForHero = false;
        this.busy = false;
        this.desktopZoom = 1;
        this.desktopPanX = 0;
        this.desktopPanY = 0;
        this.desktopDrag = null;
        this.desktopZoomLoadToken = 0;
        this.desktopZoomUpgradeFrame = 0;
        this.desktopZoomUpgradeSecondFrame = 0;
        this.desktopZoomUpgradeIdle = 0;
        this.desktopZoomUpgradeTimer = 0;
        this.desktopZoomOpenImage = null;
        this.desktopZoomOpenIndex = -1;
        this.desktopZoomOpenSource = '';
        this.desktopDialogRequestedWidth = 0;
        this.desktopDialogAppliedWidth = 0;
        if (this.sizeGuideTrigger && this.sizeGuideDetails) {
          this.sizeGuideTrigger.hidden = false;
        } else {
          if (this.sizeGuideTrigger) this.sizeGuideTrigger.hidden = true;
          if (this.sizeGuidePanel) this.sizeGuidePanel.hidden = true;
        }
        this.syncMobileMode();
        this.renderVerticalStack();
        this.updateBuyClearance();
        const selectedVariantId = Number(this.dataset.selectedVariantId);
        this.variant =
          this.variants.find((variant) => Number(variant.id) === selectedVariantId) ||
          this.variants.find((variant) => variant.available) ||
          this.variants[0] ||
          null;
        this.selectedOptions = this.variant ? [...this.variant.options] : [];
        this.bindEvents();
        this.bindSharedTransition();
        this.setActiveCategoryLink(this.activeCategoryLink, false);
        this.syncCartCount();
        this.updateRovingTabIndexes();
        this.selectionMotions = [...this.querySelectorAll('[data-tbhnp-selection-motion]')].map(group => new TbhnpSelectionMotion(group));
        this.mediaFadeStates = new Map();
        this.renderVariant(false);
        this.randomizePairCandidate();
        this.bindPairAutoOpenObserver();
        if (this.hasSharedTransitionArrival) {
          this.setActiveMedia(0, false);
        } else {
          window.requestAnimationFrame(() => this.syncGalleryToVariant(true));
        }
        this.runSharedArrival();
        this.scheduleMediaThumbnailHydration();
      }
      disconnectedCallback() {
        this.selectionMotions?.forEach(motion => motion.destroy());
        this.mediaFadeStates?.forEach(state => state.animation?.cancel());
        this.mediaFadeStates?.clear();
        this.sharedLifecycle?.abort();
        window.cancelAnimationFrame(this.categoryLabelFrame);
        window.cancelAnimationFrame(this.viewportFrame);
        window.cancelAnimationFrame(this.verticalStackFrame);
        window.cancelAnimationFrame(this.pairScrollFrame);
        window.cancelAnimationFrame(this.scrollFrame);
        this.cancelProgrammaticMediaScroll(false);
        this.cancelDesktopZoomUpgrade();
        this.disconnectMediaThumbnailHydration();
        this.pairObserver?.disconnect();
        this.pullbarObserver?.disconnect();
        this.resetPullbar();
        this.sectionElement?.classList.remove('tbhnp-mobile-pdp-section');
        this.initialized = false;
        if (!document.querySelector(elementName)) {
          document.documentElement.classList.remove('tbhnp-mobile-pdp-active');
          document.documentElement.classList.remove('tbhnp-desktop-pdp-active');
          document.documentElement.style.removeProperty(
            '--tbhnp-pdp-viewport-height'
          );
        }
      }
      updateBuyClearance() {
        if (!this.stickyBuy || !this.detailsScroll) return;
        const height = this.stickyBuy.getBoundingClientRect().height;
        if (!height) return;
        const bottom = parseFloat(getComputedStyle(this.stickyBuy).bottom) || 0;
        const clearance = Math.ceil(height + bottom + 24);
        this.style.setProperty('--tbhnp-buy-clearance', clearance + 'px');
      }
      syncViewportHeight() {
        window.cancelAnimationFrame(this.viewportFrame);
        this.viewportFrame = window.requestAnimationFrame(() => {
          this.viewportFrame = 0;
          if (!this.mobileMedia.matches) return;
          const previousOffset = this.getDetailsOffset();
          const previousProgress = this.clamp(
            (this.verticalSlides?.scrollTop || 0) / previousOffset,
            0,
            1
          );
          const wasDetails = this.detailsScreen?.classList.contains('is-active');
          const viewportHeight = Math.round(
            window.visualViewport?.height || window.innerHeight
          );
          if (viewportHeight <= 0) return;
          document.documentElement.style.setProperty(
            '--tbhnp-pdp-viewport-height',
            `${viewportHeight}px`
          );
          if (this.verticalSlides) {
            const nextOffset = this.getDetailsOffset();
            this.verticalSlides.scrollTo({
              top: wasDetails ? nextOffset : nextOffset * previousProgress,
              behavior: 'auto'
            });
          }
          this.renderVerticalStack();
        });
      }
      clamp(value, minimum, maximum) {
        return Math.min(maximum, Math.max(minimum, value));
      }
      getDetailsOffset() {
        return Math.max(1, this.detailsScreen?.offsetTop || 1);
      }
      resetPullbar() {
        this.classList.remove('tbhnp-mobile-pdp--pullbar-ready');
        this.pullbarTitle?.style.removeProperty('transform');
        this.priceElement?.style.removeProperty('transform');
        this.pullbarTitle?.style.removeProperty('opacity');
        this.priceElement?.style.removeProperty('opacity');
        this.pullbar?.style.removeProperty('top');
        this.style.removeProperty('--tbhnp-pullbar-height');
        this.pullbarGeometry = null;
        this.pullbarMeasureDirty = true;
        this.endPullbarDrag(null, true);
      }
      measurePullbar(contentShift) {
        if (!this.pullbarTitle || !this.priceElement || !this.detailsScreen) return;
        this.pullbarTitle.style.removeProperty('transform');
        this.priceElement.style.removeProperty('transform');
        const sheet = this.detailsScreen.getBoundingClientRect();
        const scroll = this.detailsScroll?.scrollTop || 0;
        const read = (node) => {
          const rect = node.getBoundingClientRect();
          return {
            x: rect.left - sheet.left,
            y: rect.top - sheet.top - contentShift + scroll,
            width: rect.width,
            height: rect.height,
            fontSize: Number.parseFloat(window.getComputedStyle(node).fontSize) || 16
          };
        };
        this.pullbarGeometry = {
          title: read(this.pullbarTitle),
          price: read(this.priceElement),
          width: sheet.width
        };
        this.pullbarMeasureDirty = false;
      }
      renderPullbar(progress, peek, contentShift) {
        if (!this.pullbar || !this.pullbarTitle || !this.priceElement) return;
        this.classList.add('tbhnp-mobile-pdp--pullbar-ready');
        if (this.pullbarMeasureDirty || !this.pullbarGeometry) {
          this.measurePullbar(contentShift);
        }
        const geometry = this.pullbarGeometry;
        if (!geometry || !geometry.title.width || !geometry.price.width) return;
        const scroll = this.detailsScroll?.scrollTop || 0;
        const priceScale = Math.min(1.08, Math.max(0.75, (geometry.width * 0.38) / geometry.price.width));
        const priceWidth = geometry.price.width * priceScale;
        const titleScale = Math.min(
          15 / geometry.title.fontSize,
          Math.max(24, peek - 26) / Math.max(1, geometry.title.height),
          Math.max(80, geometry.width - priceWidth - 66) / geometry.title.width,
          1
        );
        const position = (node, source, x, scale) => {
          const y = 16 + Math.max(0, (peek - 24 - source.height * scale) / 2);
          const remaining = 1 - progress;
          const dx = (x - source.x) * remaining;
          const dy = (y - source.y + scroll) * remaining - contentShift;
          const currentScale = scale + (1 - scale) * progress;
          node.style.transform = `translate3d(${dx.toFixed(2)}px, ${dy.toFixed(2)}px, 0) scale(${currentScale.toFixed(4)})`;
          node.style.opacity = this.reducedMotion.matches && progress > 0.04 && progress < 0.96 ? '0' : '';
        };
        position(this.pullbarTitle, geometry.title, 24, titleScale);
        position(this.priceElement, geometry.price, geometry.width - 24 - priceWidth, priceScale);
        this.pullbar.style.top = `${this.getDetailsOffset()}px`;
        this.style.setProperty('--tbhnp-pullbar-height', `${Math.max(44, peek * (1 - progress))}px`);
        const expanded = progress > 0.995;
        this.pullbar.setAttribute('aria-expanded', String(expanded));
        const label = expanded ? this.pullbar.dataset.closeLabel : this.pullbar.dataset.openLabel;
        this.pullbar.setAttribute('aria-label', `${label}: ${this.pullbarTitle.textContent.trim()} · ${this.priceElement.textContent.trim()}`);
      }
      openPullbarDetails(open) {
        if (!this.isConnected || !this.mobileMedia.matches || !this.verticalSlides) return;
        this.verticalSlides.scrollTo({
          top: open ? this.getDetailsOffset() : 0,
          behavior: this.reducedMotion.matches ? 'auto' : 'smooth'
        });
      }
      startPullbarDrag(event) {
        this.pullbarClickSuppressed = false;
        if (!this.mobileMedia.matches || event.pointerType !== 'mouse' || event.button !== 0) return;
        this.pullbarDrag = {
          pointerId: event.pointerId,
          y: event.clientY,
          scroll: this.verticalSlides.scrollTop,
          lastY: event.clientY,
          lastTime: event.timeStamp,
          velocity: 0,
          moved: false,
          snap: this.verticalSlides.style.scrollSnapType,
          behavior: this.verticalSlides.style.scrollBehavior
        };
      }
      movePullbarDrag(event) {
        const drag = this.pullbarDrag;
        if (!drag || drag.pointerId !== event.pointerId) return;
        const delta = drag.y - event.clientY;
        if (!drag.moved && Math.abs(delta) < 5) return;
        if (!drag.moved) {
          drag.moved = true;
          this.pullbar.setPointerCapture(event.pointerId);
          this.verticalSlides.style.scrollSnapType = 'none';
          this.verticalSlides.style.scrollBehavior = 'auto';
        }
        event.preventDefault();
        const elapsed = Math.max(1, event.timeStamp - drag.lastTime);
        drag.velocity = (drag.lastY - event.clientY) / elapsed;
        drag.lastY = event.clientY;
        drag.lastTime = event.timeStamp;
        this.verticalSlides.scrollTop = this.clamp(drag.scroll + delta, 0, this.getDetailsOffset());
      }
      endPullbarDrag(event, cancelled = false) {
        const drag = this.pullbarDrag;
        if (!drag) return;
        this.pullbarDrag = null;
        if (this.pullbar?.hasPointerCapture(drag.pointerId)) this.pullbar.releasePointerCapture(drag.pointerId);
        this.verticalSlides.style.scrollSnapType = drag.snap;
        this.verticalSlides.style.scrollBehavior = drag.behavior;
        this.pullbarClickSuppressed = drag.moved;
        if (!drag.moved || !this.mobileMedia.matches) return;
        const velocity = !cancelled && event && event.timeStamp - drag.lastTime < 100 ? drag.velocity : 0;
        const projected = this.verticalSlides.scrollTop + velocity * 180;
        this.openPullbarDetails(projected > this.getDetailsOffset() / 2);
      }
      renderVerticalStack() {
        this.verticalStackFrame = 0;
        this.syncBuyClearance();
        if (
          !this.mobileMedia.matches ||
          !this.verticalSlides ||
          !this.detailsScreen
        ) {
          this.classList.remove(
            'tbhnp-mobile-pdp--media-covered',
            'tbhnp-mobile-pdp--details-cue-hidden'
          );
          this.detailsScreen?.classList.remove('is-active');
          this.detailsScreen?.removeAttribute('aria-hidden');
          this.detailsScreen?.removeAttribute('inert');
          this.style.removeProperty('--tbhnp-stack-scale');
          this.style.removeProperty('--tbhnp-stack-shift');
          this.style.removeProperty('--tbhnp-stack-opacity');
          this.style.removeProperty('--tbhnp-details-content-shift');
          this.style.removeProperty('--tbhnp-details-cue-opacity');
          this.resetPullbar();
          return;
        }
        const progress = this.clamp(
          this.verticalSlides.scrollTop / this.getDetailsOffset(),
          0,
          1
        );
        const depth = progress * (2 - progress);
        const reduceMotion = this.reducedMotion.matches;
        const scale = reduceMotion ? 1 : 1 - depth * 0.044;
        const shift = reduceMotion ? 0 : -depth * 10;
        const opacity = reduceMotion ? 1 : 1 - depth * 0.05;
        const contentProgress = this.clamp((progress - 0.1) / 0.6, 0, 1);
        const peek = this.clamp(
          this.verticalSlides.clientHeight - this.getDetailsOffset(),
          0,
          this.verticalSlides.clientHeight
        );
        const contentShift = reduceMotion
          ? 0
          : (1 - contentProgress) * peek;
        const cueOpacity = 1 - this.clamp(progress / 0.12, 0, 1);
        const covered = progress > 0.12;
        const active = progress > 0.995;
        const cueHidden = cueOpacity <= 0.001;
        this.style.setProperty('--tbhnp-stack-scale', scale.toFixed(4));
        this.style.setProperty('--tbhnp-stack-shift', `${shift.toFixed(2)}px`);
        this.style.setProperty('--tbhnp-stack-opacity', opacity.toFixed(3));
        this.style.setProperty(
          '--tbhnp-details-content-shift',
          `${contentShift.toFixed(2)}px`
        );
        this.style.setProperty(
          '--tbhnp-details-cue-opacity',
          cueOpacity.toFixed(3)
        );
        this.classList.toggle('tbhnp-mobile-pdp--media-covered', covered);
        this.classList.toggle(
          'tbhnp-mobile-pdp--details-cue-hidden',
          cueHidden
        );
        this.detailsScreen.classList.toggle('is-active', active);
        this.detailsScreen.setAttribute('aria-hidden', String(!active));
        this.detailsScreen.toggleAttribute('inert', !active);
        this.dataset.stackProgress = progress.toFixed(3);
        this.renderPullbar(progress, peek, contentShift);
      }
      scheduleVerticalStack() {
        if (this.verticalStackFrame) return;
        this.verticalStackFrame = window.requestAnimationFrame(() =>
          this.renderVerticalStack()
        );
      }
      syncMobileMode() {
        const isMobile = this.mobileMedia.matches;
        const isDesktop = this.desktopMedia.matches;
        const canZoomMedia = isMobile || isDesktop;
        if (
          !isMobile &&
          (this.hasSharedTransitionArrival ||
            [1, 2].includes(Number(this.sharedTransitionState?.version)))
        ) {
          this.clearSharedTransitionState();
          this.hasSharedTransitionArrival = false;
          this.hasNativeSharedTransition = false;
          this.sharedTransitionState = null;
          this.reverseNativeArmed = false;
          this.reverseHeroGhost?.remove();
          this.reverseHeroGhost = null;
          this.sharedHero?.getAnimations?.().forEach((animation) =>
            animation.cancel()
          );
          this.sharedHero?.removeAttribute('data-view-transition-type');
          this.sharedHero?.removeAttribute(
            'data-view-transition-triggered'
          );
          this.classList.remove('tbhnp-mobile-pdp--hero-pending');
          document.documentElement.removeAttribute(
            'data-tbhnp-shared-direction'
          );
        }
        document.documentElement.classList.toggle(
          'tbhnp-mobile-pdp-active',
          isMobile
        );
        document.documentElement.classList.toggle(
          'tbhnp-desktop-pdp-active',
          isDesktop
        );
        this.sectionElement?.classList.toggle(
          'tbhnp-mobile-pdp-section',
          isMobile
        );
        this.desktopZoomImages.forEach((image, index) => {
          if (canZoomMedia) {
            const zoomLabel = this.desktopMediaDialog?.getAttribute('aria-label') || image.alt;
            image.setAttribute('role', 'button');
            image.setAttribute('tabindex', '0');
            image.setAttribute('aria-label', `${zoomLabel} ${index + 1}`);
          } else {
            image.removeAttribute('role');
            image.removeAttribute('tabindex');
            image.removeAttribute('aria-label');
          }
        });
        if (!canZoomMedia && this.desktopMediaDialog?.open) {
          this.desktopMediaDialog.close();
        }
        if (canZoomMedia && this.variant !== undefined) {
          this.hydrateMediaNeighborhood(this.activeMediaIndex, {
            eagerTarget: true
          });
        }
        if (isMobile) {
          this.scheduleMediaThumbnailHydration();
          this.syncViewportHeight();
          this.scheduleVerticalStack();
          window.scrollTo(0, 0);
          return;
        }
        if (isDesktop) this.scheduleMediaThumbnailHydration();
        else this.disconnectMediaThumbnailHydration();
        document.documentElement.style.removeProperty(
          '--tbhnp-pdp-viewport-height'
        );
        this.renderVerticalStack();
        if (!isDesktop) this.setMenuOpen(false);
      }
      readSharedTransitionState() {
        const candidates = [];
        for (const storageKey of this.sharedTransitionStorageKeys) {
          try {
            const state = JSON.parse(
              window.sessionStorage.getItem(storageKey) || 'null'
            );
            const expectedVersion = storageKey.endsWith(':v2') ? 2 : 1;
            const createdAt = Number(state?.createdAt);
            const age = Date.now() - createdAt;
            if (
              Number(state?.version) !== expectedVersion ||
              state?.direction !== 'forward' ||
              state?.productHandle !== this.dataset.productHandle ||
              typeof state?.href !== 'string' ||
              !state.href.trim() ||
              !this.sharedTransitionDestinationMatches(state?.href) ||
              !Number.isFinite(createdAt) ||
              age < 0 ||
              age > 120000
            ) {
              continue;
            }
            candidates.push({ storageKey, state });
          } catch (error) {
            // A malformed candidate must not hide a valid state in the other key.
          }
        }
        candidates.sort(
          (a, b) => Number(b.state.createdAt) - Number(a.state.createdAt)
        );
        const selected = candidates[0];
        if (!selected) return null;
        this.sharedTransitionStorageKey = selected.storageKey;
        try {
          this.sharedTransitionStorageKeys.forEach((storageKey) => {
            if (storageKey !== selected.storageKey) {
              window.sessionStorage.removeItem(storageKey);
            }
          });
        } catch (error) {
          // The selected transition remains usable even if stale cleanup fails.
        }
        return selected.state;
      }
      sharedTransitionDestinationMatches(href) {
        try {
          const normalized = (value) => {
            const url = new URL(value, window.location.href);
            ['_fd', 'pb', 'preview_theme_id'].forEach((parameter) => {
              url.searchParams.delete(parameter);
            });
            url.searchParams.sort();
            return `${url.origin}${url.pathname}${url.search}`;
          };
          return normalized(href || '') === normalized(window.location.href);
        } catch (error) {
          return false;
        }
      }
      writeSharedTransitionState(state) {
        try {
          window.sessionStorage.setItem(
            this.sharedTransitionStorageKey,
            JSON.stringify(state)
          );
        } catch (error) {
          // The product page remains fully functional without session storage.
        }
      }
      clearSharedTransitionState() {
        try {
          this.sharedTransitionStorageKeys.forEach((storageKey) => {
            window.sessionStorage.removeItem(storageKey);
          });
          if (
            window.sessionStorage.getItem('custom-transition-type') ===
            'product-image-transition'
          ) {
            window.sessionStorage.removeItem('custom-transition-type');
          }
        } catch (error) {
          // No cleanup is required when session storage is unavailable.
        }
      }
      animateSharedFallback(state) {
        if (!this.sharedHero?.animate) return;
        const fromRect = state?.rect;
        if (this.reducedMotion.matches || !fromRect) {
          const fadeAnimation = this.sharedHero.animate(
            [{ opacity: 0.78 }, { opacity: 1 }],
            {
            duration: 120,
            easing: 'linear',
            fill: 'both'
            }
          );
          fadeAnimation.finished
            .catch(() => undefined)
            .finally(() => fadeAnimation.cancel());
          return;
        }
        const toRect = this.sharedHero.getBoundingClientRect();
        if (!toRect.width || !toRect.height) return;
        const deltaX = Number(fromRect.left) - toRect.left;
        const deltaY = Number(fromRect.top) - toRect.top;
        const scale = Number(fromRect.width) / toRect.width;
        const heightScale = Number(fromRect.height) / toRect.height;
        if (
          !Number.isFinite(scale) ||
          !Number.isFinite(heightScale) ||
          Math.abs(scale - heightScale) > 0.002
        ) {
          const fadeAnimation = this.sharedHero.animate(
            [{ opacity: 0.78 }, { opacity: 1 }],
            {
              duration: 120,
              easing: 'linear',
              fill: 'both'
            }
          );
          fadeAnimation.finished
            .catch(() => undefined)
            .finally(() => fadeAnimation.cancel());
          return;
        }
        const storedClip = Number(state?.clipBottom);
        const startClip = Number.isFinite(storedClip)
          ? Math.min(6.25, Math.max(0, storedClip))
          : 6.25;
        const animation = this.sharedHero.animate(
          [
            {
              offset: 0,
              transformOrigin: '0 0',
              transform: `translate(${deltaX}px, ${deltaY}px) scale(${scale})`,
              clipPath: `inset(0 0 ${startClip}% 0)`,
              opacity: 0.9
            },
            {
              offset: 0.72,
              clipPath: 'inset(0 0 1.4% 0)',
              opacity: 1
            },
            {
              offset: 1,
              transformOrigin: '0 0',
              transform: 'translate(0, 0) scale(1)',
              clipPath: 'inset(0)',
              opacity: 1
            }
          ],
          {
            duration: 380,
            easing: 'cubic-bezier(0.22, 1, 0.36, 1)',
            fill: 'both'
          }
        );
        animation.finished
          .catch(() => undefined)
          .finally(() => animation.cancel());
      }
      getReturnHeroRect() {
        const rect = this.sharedHero?.getBoundingClientRect();
        if (!rect) return null;
        const isVisible =
          this.activeMediaIndex === 0 &&
          rect.bottom > 0 &&
          rect.top < window.innerHeight &&
          rect.right > 0 &&
          rect.left < window.innerWidth;
        if (isVisible) {
          return {
            top: rect.top,
            left: rect.left,
            width: rect.width,
            height: rect.height
          };
        }
        return {
          top: (window.innerHeight - rect.height) / 2,
          left: (window.innerWidth - rect.width) / 2,
          width: rect.width,
          height: rect.height
        };
      }
      createReturnHero() {
        const rect = this.getReturnHeroRect();
        if (!rect || !this.sharedHero) return null;
        const currentRect = this.sharedHero.getBoundingClientRect();
        const alreadyAtReturnRect =
          Math.abs(currentRect.top - rect.top) < 0.5 &&
          Math.abs(currentRect.left - rect.left) < 0.5;
        if (alreadyAtReturnRect && this.activeMediaIndex === 0) {
          this.reverseHeroRect = rect;
          return this.sharedHero;
        }
        const ghost = this.sharedHero.cloneNode(false);
        const computedStyle = window.getComputedStyle(this.sharedHero);
        this.sharedHero.removeAttribute('data-view-transition-type');
        this.sharedHero.removeAttribute('data-view-transition-triggered');
        ghost.classList.add('tbhnp-mobile-pdp__return-hero');
        Object.assign(ghost.style, {
          position: 'fixed',
          zIndex: '100',
          top: `${rect.top}px`,
          left: `${rect.left}px`,
          width: `${rect.width}px`,
          height: `${rect.height}px`,
          maxWidth: 'none',
          objectFit: 'contain',
          objectPosition: '50% 50%',
          filter: computedStyle.filter,
          transform: 'scale(1)',
          transformOrigin: '50% 50%',
          pointerEvents: 'none'
        });
        document.body.append(ghost);
        this.reverseHeroRect = rect;
        this.reverseHeroGhost = ghost;
        return ghost;
      }
      bindSharedTransition() {
        const { signal } = this.sharedLifecycle;
        document.addEventListener(
          'click',
          (event) => {
            const link = event.target?.closest?.('a[href]');
            if (
              !link ||
              event.button !== 0 ||
              event.metaKey ||
              event.ctrlKey ||
              event.shiftKey ||
              event.altKey ||
              (link.target && link.target !== '_self') ||
              link.hasAttribute('download')
            ) {
              return;
            }
            let destination;
            try {
              destination = new URL(link.href, window.location.href);
            } catch (error) {
              return;
            }
            const rawHref = (link.getAttribute('href') || '').trim();
            const isSameDocumentHash =
              rawHref.startsWith('#') ||
              (destination.origin === window.location.origin &&
                destination.pathname === window.location.pathname &&
                destination.search === window.location.search &&
                destination.hash !== window.location.hash);
            if (isSameDocumentHash) return;
            const markNavigation = () => {
              if (event.defaultPrevented || !link.isConnected) return;
              this.navigationWasLinkActivated = true;
              this.sharedHero?.removeAttribute(
                'data-view-transition-triggered'
              );
            };
            if (typeof window.queueMicrotask === 'function') {
              window.queueMicrotask(markNavigation);
            } else {
              Promise.resolve().then(markNavigation);
            }
          },
          { capture: true, signal }
        );
        window.addEventListener(
          'pageswap',
          (event) => {
            this.cancelProgrammaticMediaScroll(true);
            this.cancelDesktopZoomUpgrade();
            if (
              !this.hasSharedTransitionArrival ||
              !this.hasNativeSharedTransition ||
              !this.mobileMedia.matches ||
              this.reducedMotion.matches ||
              this.navigationWasLinkActivated ||
              !event.viewTransition
            ) {
              return;
            }
            const activation = event.activation;
            let destinationPath = '';
            try {
              const destinationUrl = new URL(
                activation?.entry?.url || '',
                window.location.href
              );
              destinationPath =
                Number(this.sharedTransitionState?.version) === 1
                  ? destinationUrl.pathname
                  : destinationUrl.pathname + destinationUrl.search;
            } catch (error) {
              return;
            }
            const originPath =
              Number(this.sharedTransitionState?.version) === 1
                ? this.sharedTransitionState.originPathname
                : this.sharedTransitionState.originPath;
            if (
              activation?.navigationType !== 'traverse' ||
              destinationPath !== originPath
            ) {
              return;
            }
            document.documentElement.dataset.tbhnpSharedDirection = 'back';
            const transitionHero = this.createReturnHero();
            transitionHero?.setAttribute(
              'data-view-transition-type',
              'product-image-transition'
            );
            transitionHero?.setAttribute(
              'data-view-transition-triggered',
              'true'
            );
            event.viewTransition.types.clear();
            event.viewTransition.types.add('product-image-transition');
            this.reverseNativeArmed = true;
            try {
              window.sessionStorage.setItem(
                'custom-transition-type',
                'product-image-transition'
              );
            } catch (error) {
              // The global Horizon handler still provides a normal page transition.
            }
            event.viewTransition.finished.finally(() => {
              this.reverseHeroGhost?.remove();
              this.reverseHeroGhost = null;
              if (
                document.documentElement.dataset.tbhnpSharedDirection ===
                'back'
              ) {
                document.documentElement.removeAttribute(
                  'data-tbhnp-shared-direction'
                );
              }
            });
          },
          { signal }
        );
        window.addEventListener(
          'pagehide',
          () => {
            this.cancelProgrammaticMediaScroll(true);
            this.cancelDesktopZoomUpgrade();
            if (this.navigationWasLinkActivated) {
              this.clearSharedTransitionState();
              document.documentElement.removeAttribute(
                'data-tbhnp-shared-direction'
              );
              return;
            }
            if (!this.mobileMedia.matches) {
              this.clearSharedTransitionState();
              document.documentElement.removeAttribute(
                'data-tbhnp-shared-direction'
              );
              return;
            }
            if (!this.hasSharedTransitionArrival) return;
            const rect = this.reverseHeroRect || this.getReturnHeroRect();
            if (!rect) return;
            this.writeSharedTransitionState({
              ...this.sharedTransitionState,
              direction: 'back',
              nativeViewTransition: this.reverseNativeArmed,
              createdAt: Date.now(),
              rect
            });
          },
          { signal }
        );
      }
      runSharedArrival() {
        if (this.hasSharedTransitionArrival && !this.reducedMotion.matches) {
          document.documentElement.dataset.tbhnpSharedDirection = 'forward';
        }
        const settle = () => {
          this.classList.remove('tbhnp-mobile-pdp--hero-pending');
          if (
            document.documentElement.dataset.tbhnpSharedDirection ===
            'forward'
          ) {
            document.documentElement.removeAttribute(
              'data-tbhnp-shared-direction'
            );
          }
          if (
            this.hasSharedTransitionArrival &&
            !this.reducedMotion.matches &&
            !this.navigationWasLinkActivated
          ) {
            this.sharedHero?.setAttribute(
              'data-view-transition-type',
              'product-image-transition'
            );
            this.sharedHero?.setAttribute(
              'data-view-transition-triggered',
              'true'
            );
          }
        };
        if (!this.hasSharedTransitionArrival || !this.sharedHero) {
          window.requestAnimationFrame(settle);
          return;
        }
        const arrivalStartedAt =
          window.performance?.now?.() || Date.now();
        const arrivalToken = Number(
          this.sharedTransitionState?.createdAt || 0
        );
        const imageReady = new Promise((resolve) => {
          let completed = false;
          let readinessTimeout = 0;
          const done = () => {
            if (completed) return;
            completed = true;
            window.clearTimeout(readinessTimeout);
            this.sharedHero.removeEventListener('load', done);
            this.sharedHero.removeEventListener('error', done);
            resolve();
          };
          readinessTimeout = window.setTimeout(done, 420);
          if (this.sharedHero.complete) {
            if (typeof this.sharedHero.decode === 'function') {
              this.sharedHero.decode().then(done, done);
            } else {
              done();
            }
            return;
          }
          this.sharedHero.addEventListener('load', done, { once: true });
          this.sharedHero.addEventListener('error', done, { once: true });
          if (typeof this.sharedHero.decode === 'function') {
            this.sharedHero.decode().then(done, () => undefined);
          }
        });
        imageReady.then(() => {
          if (
            !this.mobileMedia.matches ||
            !this.hasSharedTransitionArrival ||
            Number(this.sharedTransitionState?.createdAt || 0) !==
              arrivalToken
          ) {
            return;
          }
          const usesFallback =
            !this.hasNativeSharedTransition ||
            this.reducedMotion.matches;
          if (usesFallback) {
            this.animateSharedFallback(this.sharedTransitionState);
          }
          const elapsed =
            (window.performance?.now?.() || Date.now()) -
            arrivalStartedAt;
          const settleDelay = usesFallback
            ? this.reducedMotion.matches
              ? 120
              : 420
            : Math.max(0, 420 - elapsed);
          window.setTimeout(settle, settleDelay);
        });
      }
      parseJSON(selector, fallback) {
        const element = this.querySelector(selector);
        if (!element) return fallback;
        try {
          return JSON.parse(element.textContent);
        } catch (error) {
          return fallback;
        }
      }
      translate(key, replacements = {}) {
        let value = String(this.i18n?.[key] || '');
        Object.entries(replacements).forEach(([token, replacement]) => {
          value = value.split(token).join(String(replacement));
        });
        return value;
      }
      positionCategoryLabel() {
        this.categoryLabelFrame = 0;
        if (
          !this.categoryLabel ||
          !this.categoryPanel ||
          !this.categoryCapsule ||
          !this.activeCategoryLink ||
          !this.isMenuOpen
        ) {
          this.categoryLabel?.classList.remove('is-visible');
          return;
        }
        this.categoryLabel.textContent =
          this.activeCategoryLink.dataset.category.toUpperCase();
        const linkBounds = this.activeCategoryLink.getBoundingClientRect();
        const panelBounds = this.categoryPanel.getBoundingClientRect();
        const capsuleBounds = this.categoryCapsule.getBoundingClientRect();
        const isFullyVisible =
          linkBounds.top >= capsuleBounds.top + 4 &&
          linkBounds.bottom <= capsuleBounds.bottom - 4;
        this.categoryLabel.style.top =
          `${linkBounds.top - panelBounds.top + 7}px`;
        this.categoryLabel.classList.toggle('is-visible', isFullyVisible);
      }
      scheduleCategoryLabel() {
        if (this.categoryLabelFrame) return;
        this.categoryLabelFrame = window.requestAnimationFrame(() => {
          this.positionCategoryLabel();
        });
      }
      setActiveCategoryLink(nextLink, announce = true) {
        if (!nextLink) return;
        this.categoryLinks.forEach((link) => {
          link.classList.toggle('is-active', link === nextLink);
        });
        this.activeCategoryLink = nextLink;
        if (announce && this.menuStatus) {
          this.menuStatus.textContent = `${this.translate('navigationPrefix')}: ${nextLink.dataset.category}`;
        }
        if (
          this.isMenuOpen &&
          this.categoryCapsule &&
          this.categoryPanel
        ) {
          const linkBounds = nextLink.getBoundingClientRect();
          const capsuleBounds = this.categoryCapsule.getBoundingClientRect();
          const isFullyVisible =
            linkBounds.top >= capsuleBounds.top + 4 &&
            linkBounds.bottom <= capsuleBounds.bottom - 4;
          if (!isFullyVisible) {
            nextLink.scrollIntoView({
              block: 'nearest',
              inline: 'nearest',
              behavior: this.reducedMotion.matches ? 'auto' : 'smooth'
            });
          }
        }
        this.scheduleCategoryLabel();
      }
      setMenuOpen(nextOpen, returnFocus = false) {
        if (
          !this.utilityMenu ||
          !this.menuToggle ||
          !this.menuGlyph ||
          !this.categoryPanel
        ) {
          this.isMenuOpen = false;
          return;
        }
        if (nextOpen === this.isMenuOpen) return;
        this.isMenuOpen = nextOpen;
        this.utilityMenu.classList.toggle('is-open', nextOpen);
        this.menuToggle.setAttribute('aria-expanded', String(nextOpen));
        this.menuToggle.setAttribute(
          'aria-label',
          nextOpen ? this.translate('closeMenu') : this.translate('openMenu')
        );
        this.categoryPanel.setAttribute('aria-hidden', String(!nextOpen));
        if (nextOpen) {
          this.categoryPanel.removeAttribute('inert');
          this.setActiveCategoryLink(this.activeCategoryLink, false);
          this.scheduleCategoryLabel();
          window.setTimeout(() => this.scheduleCategoryLabel(), 260);
          return;
        }
        this.categoryLabel?.classList.remove('is-visible');
        const shouldReturnFocus =
          returnFocus || this.categoryPanel.contains(document.activeElement);
        this.categoryPanel.setAttribute('inert', '');
        if (shouldReturnFocus) this.menuToggle.focus();
      }
      updateCartCount(itemCount) {
        if (!this.cartCount || !this.cartToggle) return;
        const normalizedCount =
          Number.isFinite(itemCount) && itemCount > 0
            ? Math.floor(itemCount)
            : 0;
        this.cartCount.textContent = String(normalizedCount);
        this.cartCount.hidden = normalizedCount === 0;
        this.cartToggle.setAttribute(
          'aria-label',
          this.translate('openCart', { __COUNT__: normalizedCount })
        );
      }
      syncCartCount() {
        const nativeCount = document.querySelector(
          '[data-testid="cart-icon"] .cart-bubble__text-count'
        );
        const value = nativeCount?.textContent.match(/\d+/)?.[0];
        this.updateCartCount(Number.parseInt(value || '0', 10));
      }
      openCart() {
        this.setMenuOpen(false);
        const cartDrawer = document.querySelector('cart-drawer-component');
        if (typeof cartDrawer?.open === 'function') {
          cartDrawer.open();
          return;
        }
        document.querySelector('[data-testid="cart-drawer-trigger"]')?.click();
      }
      async openSearch() {
        this.setMenuOpen(false);
        const searchModal = document.querySelector('#search-modal');
        if (!searchModal) {
          window.location.assign(this.dataset.searchUrl || '/search');
          return;
        }
        if (window.customElements?.whenDefined) {
          await Promise.race([
            window.customElements.whenDefined('dialog-component'),
            new Promise((resolve) => window.setTimeout(resolve, 500))
          ]);
        }
        if (typeof searchModal.showDialog === 'function') {
          searchModal.showDialog();
          return;
        }
        searchModal.querySelector('dialog')?.showModal();
      }
      bindEvents() {
        const { signal } = this.sharedLifecycle;
        this.mediaSlides.forEach((slide, index) => {
          const preview = slide.querySelector('[data-gallery-preview-image]');
          const image =
            slide.querySelector('[data-gallery-deferred-image]') ||
            slide.querySelector(
              '.tbhnp-mobile-pdp__media-image:not([data-gallery-preview-image])'
            );
          preview?.addEventListener(
            'load',
            () => this.markGalleryPreviewReady(index, preview),
            { signal }
          );
          preview?.addEventListener(
            'error',
            () => this.markGalleryPreviewFailed(index, preview),
            { signal }
          );
          image?.addEventListener(
            'load',
            () => {
              if (image.matches('[data-gallery-deferred-image]')) {
                this.markGalleryImageReady(index, image);
                return;
              }
              this.preparePredictedGalleryPreview(index);
            },
            { signal }
          );
        });
        this.mediaPages.forEach((button) => {
          button.addEventListener('click', () => {
            this.setActiveMedia(Number(button.dataset.mediaPage), true);
          }, { signal });
        });
        this.galleryTrack?.addEventListener(
          'scroll',
          () => this.syncMediaFromScroll(),
          { passive: true, signal }
        );
        this.galleryTrack?.addEventListener(
          'scrollend',
          () => {
            if (!this.galleryPointerDown) this.galleryGestureActive = false;
            this.galleryLastScrollLeft = this.galleryTrack?.scrollLeft || 0;
            const state = this.programmaticMediaScroll;
            if (
              state &&
              Math.abs(this.galleryTrack.scrollLeft - state.targetLeft) <= 1
            ) {
              this.finishProgrammaticMediaScroll(state.generation);
            }
          },
          { passive: true, signal }
        );
        const beginGalleryGesture = () => {
          this.galleryGestureActive = true;
          this.galleryPointerDown = true;
          this.galleryLastScrollLeft = this.galleryTrack?.scrollLeft || 0;
          this.cancelProgrammaticMediaScroll(true, true);
        };
        const beginGalleryWheel = () => {
          this.galleryGestureActive = true;
          this.galleryPointerDown = false;
          this.galleryLastScrollLeft = this.galleryTrack?.scrollLeft || 0;
          this.cancelProgrammaticMediaScroll(true, true);
        };
        const endGalleryGesture = () => {
          this.galleryPointerDown = false;
        };
        this.galleryTrack?.addEventListener(
          'pointerdown',
          beginGalleryGesture,
          { passive: true, signal }
        );
        this.galleryTrack?.addEventListener(
          'touchstart',
          beginGalleryGesture,
          { passive: true, signal }
        );
        this.galleryTrack?.addEventListener(
          'wheel',
          beginGalleryWheel,
          { passive: true, signal }
        );
        ['pointerup', 'pointercancel', 'touchend', 'touchcancel'].forEach(
          (eventName) => {
            this.galleryTrack?.addEventListener(eventName, endGalleryGesture, {
              passive: true,
              signal
            });
          }
        );
        this.desktopZoomImages.forEach((image, index) => {
          image.addEventListener('click', () => {
            if (this.desktopMedia.matches || this.mobileMedia.matches) {
              this.openDesktopMediaDialog(image, index);
            }
          }, { signal });
          image.addEventListener('keydown', (event) => {
            if (!this.desktopMedia.matches && !this.mobileMedia.matches) return;
            if (event.key !== 'Enter' && event.key !== ' ') return;
            event.preventDefault();
            this.openDesktopMediaDialog(image, index);
          }, { signal });
        });
        this.querySelector('[data-desktop-media-close]')?.addEventListener(
          'click',
          () => this.desktopMediaDialog?.close(),
          { signal }
        );
        this.desktopZoomOut?.addEventListener(
          'click',
          () => this.setDesktopZoom(this.desktopZoom - 0.25),
          { signal }
        );
        this.desktopZoomReset?.addEventListener(
          'click',
          () => this.resetDesktopZoom(),
          { signal }
        );
        this.desktopZoomIn?.addEventListener(
          'click',
          () => this.setDesktopZoom(this.desktopZoom + 0.25),
          { signal }
        );
        this.desktopDialogViewport?.addEventListener('wheel', (event) => {
          if (!this.desktopMediaDialog?.open) return;
          event.preventDefault();
          this.setDesktopZoom(
            this.desktopZoom + (event.deltaY < 0 ? 0.2 : -0.2),
            { x: event.clientX, y: event.clientY }
          );
        }, { passive: false, signal });
        this.desktopDialogViewport?.addEventListener('dblclick', (event) => {
          this.setDesktopZoom(
            this.desktopZoom > 1 ? 1 : 2,
            { x: event.clientX, y: event.clientY }
          );
        }, { signal });
        this.desktopDialogViewport?.addEventListener(
          'pointerdown',
          (event) => this.startDesktopDrag(event),
          { signal }
        );
        this.desktopDialogViewport?.addEventListener(
          'pointermove',
          (event) => this.moveDesktopDrag(event),
          { signal }
        );
        this.desktopDialogViewport?.addEventListener(
          'pointerup',
          (event) => this.endDesktopDrag(event),
          { signal }
        );
        this.desktopDialogViewport?.addEventListener(
          'pointercancel',
          (event) => this.endDesktopDrag(event),
          { signal }
        );
        this.desktopMediaDialog?.addEventListener('click', (event) => {
          if (event.target === this.desktopMediaDialog) {
            this.desktopMediaDialog.close();
          }
        }, { signal });
        this.desktopMediaDialog?.addEventListener(
          'close',
          () => {
            this.cancelDesktopZoomUpgrade();
            this.resetDesktopZoom();
            this.desktopDialogImage?.removeAttribute('src');
            this.desktopZoomOpenImage = null;
            this.desktopZoomOpenIndex = -1;
            this.desktopZoomOpenSource = '';
            this.desktopDialogRequestedWidth = 0;
            this.desktopDialogAppliedWidth = 0;
          },
          { signal }
        );
        this.desktopMediaDialog?.addEventListener(
          'keydown',
          (event) => this.handleDesktopDialogKeydown(event),
          { signal }
        );
        this.optionButtons.forEach((button) => {
          button.addEventListener(
            'click',
            () => this.selectOption(button),
            { signal }
          );
          button.addEventListener('keydown', (event) => {
            this.handleOptionKeydown(event, button);
          }, { signal });
        });
        this.addButton?.addEventListener(
          'click',
          () => this.addToCart(),
          { signal }
        );
        this.sizeGuideTrigger?.addEventListener(
          'click',
          () => this.toggleSizeGuide(),
          { signal }
        );
        this.pairTrigger?.addEventListener(
          'click',
          () => {
            this.pairUserInteracted = true;
            const shouldOpen =
              this.pairTrigger.getAttribute('aria-expanded') !== 'true';
            this.setPairOpen(shouldOpen, { scroll: shouldOpen });
          },
          { signal }
        );
        this.detailsScroll?.addEventListener(
          'scroll',
          () => this.schedulePairAutoOpen(),
          { passive: true, signal }
        );
        this.detailsScroll?.addEventListener(
          'scrollend',
          () => this.schedulePairAutoOpen(),
          { passive: true, signal }
        );
        this.detailsScroll?.addEventListener(
          'touchend',
          () => {
            window.setTimeout(() => this.schedulePairAutoOpen(), 180);
          },
          { passive: true, signal }
        );
        this.verticalSlides?.addEventListener(
          'scroll',
          () => {
            if (this.isMenuOpen) this.setMenuOpen(false);
            this.scheduleVerticalStack();
            this.schedulePairAutoOpen();
          },
          { passive: true, signal }
        );
        this.pullbar?.addEventListener('click', () => {
          if (this.pullbarClickSuppressed) {
            this.pullbarClickSuppressed = false;
            return;
          }
          this.openPullbarDetails(this.verticalSlides.scrollTop < this.getDetailsOffset() / 2);
        }, { signal });
        this.pullbar?.addEventListener('keydown', (event) => {
          if (!['ArrowUp', 'ArrowDown', 'Escape'].includes(event.key)) return;
          event.preventDefault();
          this.openPullbarDetails(event.key === 'ArrowUp');
        }, { signal });
        this.pullbar?.addEventListener('pointerdown', (event) => this.startPullbarDrag(event), { signal });
        this.pullbar?.addEventListener('pointermove', (event) => this.movePullbarDrag(event), { signal });
        this.pullbar?.addEventListener('pointerup', (event) => this.endPullbarDrag(event), { signal });
        this.pullbar?.addEventListener('pointercancel', (event) => this.endPullbarDrag(event, true), { signal });
        this.menuToggle?.addEventListener(
          'click',
          () => this.setMenuOpen(!this.isMenuOpen),
          { signal }
        );
        this.categoryPanel?.addEventListener(
          'click',
          (event) => {
            const nextLink = event.target.closest('.tbhnp-category-link');
            if (nextLink) this.setActiveCategoryLink(nextLink);
          },
          { signal }
        );
        this.categoryPanel?.addEventListener(
          'focusin',
          (event) => {
            const nextLink = event.target.closest('.tbhnp-category-link');
            if (nextLink) this.setActiveCategoryLink(nextLink, false);
          },
          { signal }
        );
        this.categoryCapsule?.addEventListener(
          'scroll',
          () => this.scheduleCategoryLabel(),
          { passive: true, signal }
        );
        this.categoryPanel?.addEventListener(
          'keydown',
          (event) => {
            const currentIndex = this.categoryLinks.indexOf(
              document.activeElement
            );
            if (currentIndex < 0) return;
            const keyMoves = {
              ArrowDown: (currentIndex + 1) % this.categoryLinks.length,
              ArrowRight: (currentIndex + 1) % this.categoryLinks.length,
              ArrowUp:
                (currentIndex - 1 + this.categoryLinks.length) %
                this.categoryLinks.length,
              ArrowLeft:
                (currentIndex - 1 + this.categoryLinks.length) %
                this.categoryLinks.length,
              Home: 0,
              End: this.categoryLinks.length - 1
            };
            const nextIndex = keyMoves[event.key];
            if (nextIndex === undefined) return;
            event.preventDefault();
            this.categoryLinks[nextIndex].focus();
          },
          { signal }
        );
        this.cartToggle?.addEventListener(
          'click',
          () => this.openCart(),
          { signal }
        );
        this.searchToggle?.addEventListener(
          'click',
          () => this.openSearch(),
          { signal }
        );
        document.addEventListener(
          'keydown',
          (event) => {
            if (event.key !== 'Escape' || !this.isMenuOpen) return;
            event.preventDefault();
            this.setMenuOpen(false, true);
          },
          { signal }
        );
        document.addEventListener(
          'cart:update',
          (event) => {
            const itemCount = Number(
              event.detail?.data?.itemCount ??
                event.detail?.resource?.item_count ??
                0
            );
            this.updateCartCount(itemCount);
          },
          { signal }
        );
        window.addEventListener(
          'pageshow',
          () => {
            this.syncMobileMode();
            this.syncCartCount();
          },
          { signal }
        );
        const handleViewportResize = () => {
          this.galleryGestureActive = false;
          this.galleryPointerDown = false;
          this.galleryLastScrollLeft = this.galleryTrack?.scrollLeft || 0;
          if (this.programmaticMediaScroll) {
            this.cancelProgrammaticMediaScroll(true, true);
          }
          this.syncViewportHeight();
          this.syncAddButtonGlass();
          this.scheduleCategoryLabel();
          if (this.desktopMediaDialog?.open) this.renderDesktopZoom();
        };
        window.addEventListener('resize', handleViewportResize, { signal });
        window.visualViewport?.addEventListener(
          'resize',
          handleViewportResize,
          { signal }
        );
        this.mobileMedia.addEventListener(
          'change',
          () => this.syncMobileMode(),
          { signal }
        );
        this.desktopMedia.addEventListener(
          'change',
          () => this.syncMobileMode(),
          { signal }
        );
      }
      openDesktopMediaDialog(image, index) {
        if (
          (!this.desktopMedia.matches && !this.mobileMedia.matches) ||
          !this.desktopMediaDialog ||
          !this.desktopDialogImage
        ) return;
        this.cancelDesktopZoomUpgrade();
        const loadToken = this.desktopZoomLoadToken;
        const renderedSource =
          image.naturalWidth > 1 &&
          image.currentSrc &&
          !image.currentSrc.startsWith('data:')
            ? image.currentSrc
            : '';
        const zoomSource =
          image.dataset.desktopZoomSource ||
          image.dataset.gallerySrc ||
          image.src;
        const previewSource =
          renderedSource || this.imageURLAtWidth(zoomSource, 900);
        if (previewSource) this.desktopDialogImage.src = previewSource;
        this.desktopDialogImage.alt = image.alt;
        this.desktopZoomOpenImage = image;
        this.desktopZoomOpenIndex = index;
        this.desktopZoomOpenSource = zoomSource;
        this.desktopDialogRequestedWidth = 0;
        this.desktopDialogAppliedWidth = 0;
        if (this.desktopDialogCount) {
          const current = String(index + 1).padStart(2, '0');
          const total = String(this.desktopZoomImages.length).padStart(2, '0');
          this.desktopDialogCount.textContent = `${current} / ${total}`;
        }
        if (!this.desktopMediaDialog.open) this.desktopMediaDialog.showModal();
        this.desktopZoomUpgradeFrame = window.requestAnimationFrame(() => {
          if (!this.isDesktopZoomLoadCurrent(loadToken, image, index)) return;
          this.resetDesktopZoom();
          if (this.mobileMedia.matches) this.setDesktopZoom(1.5);
          this.desktopZoomUpgradeSecondFrame = window.requestAnimationFrame(() => {
            if (!this.isDesktopZoomLoadCurrent(loadToken, image, index)) return;
            const startUpgrade = () => {
              this.desktopZoomUpgradeIdle = 0;
              this.desktopZoomUpgradeTimer = 0;
              void this.loadDesktopDialogHighRes(image, index, loadToken);
            };
            if ('requestIdleCallback' in window) {
              this.desktopZoomUpgradeIdle = window.requestIdleCallback(
                startUpgrade,
                { timeout: 700 }
              );
            } else {
              this.desktopZoomUpgradeTimer = window.setTimeout(
                startUpgrade,
                120
              );
            }
          });
        });
      }
      cancelDesktopZoomUpgrade() {
        this.desktopZoomLoadToken += 1;
        window.cancelAnimationFrame(this.desktopZoomUpgradeFrame);
        window.cancelAnimationFrame(this.desktopZoomUpgradeSecondFrame);
        window.clearTimeout(this.desktopZoomUpgradeTimer);
        if (
          this.desktopZoomUpgradeIdle &&
          'cancelIdleCallback' in window
        ) {
          window.cancelIdleCallback(this.desktopZoomUpgradeIdle);
        }
        this.desktopZoomUpgradeFrame = 0;
        this.desktopZoomUpgradeSecondFrame = 0;
        this.desktopZoomUpgradeIdle = 0;
        this.desktopZoomUpgradeTimer = 0;
      }
      isDesktopZoomLoadCurrent(loadToken, image, index) {
        return (
          this.isConnected &&
          this.desktopMediaDialog?.open &&
          loadToken === this.desktopZoomLoadToken &&
          image === this.desktopZoomOpenImage &&
          index === this.desktopZoomOpenIndex
        );
      }
      imageURLAtWidth(source, width) {
        if (!source || source.startsWith('data:')) return '';
        try {
          const imageUrl = new URL(source, window.location.href);
          imageUrl.searchParams.set('width', String(width));
          return imageUrl.toString();
        } catch (error) {
          return source;
        }
      }
      getDesktopDialogImageWidth() {
        const viewportWidth =
          this.desktopDialogViewport?.clientWidth || window.innerWidth || 1;
        const pixelRatio = Math.min(
          3,
          Math.max(1, window.devicePixelRatio || 1)
        );
        const maximum = this.mobileMedia.matches ? 2000 : 2560;
        const target = Math.min(
          maximum,
          viewportWidth * pixelRatio * (this.mobileMedia.matches ? 1.5 : 1.25)
        );
        const buckets = [1200, 1600, 2000, 2560].filter(
          (width) => width <= maximum
        );
        return buckets.find((width) => width >= target) || maximum;
      }
      async loadDesktopDialogHighRes(
        image,
        index,
        loadToken,
        requestedWidth = this.getDesktopDialogImageWidth()
      ) {
        if (!this.isDesktopZoomLoadCurrent(loadToken, image, index)) return;
        const source = image.dataset.desktopZoomSource || this.desktopZoomOpenSource;
        const targetWidth = Math.max(1, Math.round(requestedWidth));
        if (
          !source ||
          targetWidth <= this.desktopDialogAppliedWidth ||
          targetWidth < this.desktopDialogRequestedWidth ||
          targetWidth === this.desktopDialogRequestedWidth
        ) {
          return;
        }
        const highResSource = this.imageURLAtWidth(source, targetWidth);
        if (!highResSource) return;
        if (highResSource === this.desktopDialogImage.currentSrc) {
          this.desktopDialogRequestedWidth = targetWidth;
          this.desktopDialogAppliedWidth = targetWidth;
          return;
        }
        this.desktopDialogRequestedWidth = targetWidth;
        const loader = new Image();
        loader.decoding = 'async';
        loader.fetchPriority = 'low';
        loader.src = highResSource;
        try {
          if (typeof loader.decode === 'function') {
            await loader.decode();
          } else {
            await new Promise((resolve, reject) => {
              loader.addEventListener('load', resolve, { once: true });
              loader.addEventListener('error', reject, { once: true });
            });
          }
        } catch (error) {
          if (!loader.complete || loader.naturalWidth <= 1) {
            if (targetWidth === this.desktopDialogRequestedWidth) {
              this.desktopDialogRequestedWidth = this.desktopDialogAppliedWidth;
            }
            return;
          }
        }
        if (
          !this.isDesktopZoomLoadCurrent(loadToken, image, index) ||
          targetWidth !== this.desktopDialogRequestedWidth
        ) {
          return;
        }
        if (this.desktopDrag) {
          this.desktopDialogRequestedWidth = this.desktopDialogAppliedWidth;
          return;
        }
        this.desktopDialogImage.src = highResSource;
        this.desktopDialogAppliedWidth = targetWidth;
      }
      clampDesktopValue(value, minimum, maximum) {
        return Math.min(maximum, Math.max(minimum, value));
      }
      clampDesktopPan() {
        if (!this.desktopDialogViewport) return;
        const maxX = (this.desktopDialogViewport.clientWidth * (this.desktopZoom - 1)) / 2;
        const maxY = (this.desktopDialogViewport.clientHeight * (this.desktopZoom - 1)) / 2;
        this.desktopPanX = this.clampDesktopValue(this.desktopPanX, -maxX, maxX);
        this.desktopPanY = this.clampDesktopValue(this.desktopPanY, -maxY, maxY);
      }
      renderDesktopZoom() {
        if (!this.desktopDialogViewport) return;
        this.clampDesktopPan();
        this.desktopDialogViewport.style.setProperty('--tbhnp-dialog-zoom', String(this.desktopZoom));
        this.desktopDialogViewport.style.setProperty('--tbhnp-dialog-pan-x', `${this.desktopPanX}px`);
        this.desktopDialogViewport.style.setProperty('--tbhnp-dialog-pan-y', `${this.desktopPanY}px`);
        if (this.desktopZoomLevel) {
          this.desktopZoomLevel.textContent = `${Math.round(this.desktopZoom * 100)}%`;
        }
        if (this.desktopZoomOut) this.desktopZoomOut.disabled = this.desktopZoom <= 1;
        if (this.desktopZoomIn) this.desktopZoomIn.disabled = this.desktopZoom >= 3;
        if (this.desktopZoomReset) {
          this.desktopZoomReset.disabled =
            this.desktopZoom === 1 && this.desktopPanX === 0 && this.desktopPanY === 0;
        }
      }
      setDesktopZoom(nextZoom, focalPoint) {
        const previousZoom = this.desktopZoom;
        this.desktopZoom = this.clampDesktopValue(
          Math.round(nextZoom * 100) / 100,
          1,
          3
        );
        if (this.desktopZoom === 1) {
          this.desktopPanX = 0;
          this.desktopPanY = 0;
        } else if (focalPoint && previousZoom !== this.desktopZoom && this.desktopDialogViewport) {
          const rect = this.desktopDialogViewport.getBoundingClientRect();
          const focalX = focalPoint.x - rect.left - rect.width / 2;
          const focalY = focalPoint.y - rect.top - rect.height / 2;
          const imageX = (focalX - this.desktopPanX) / previousZoom;
          const imageY = (focalY - this.desktopPanY) / previousZoom;
          this.desktopPanX = focalX - imageX * this.desktopZoom;
          this.desktopPanY = focalY - imageY * this.desktopZoom;
        }
        this.renderDesktopZoom();
        if (
          this.desktopZoom >= 2.25 &&
          this.desktopZoomOpenImage &&
          this.desktopMediaDialog?.open
        ) {
          void this.loadDesktopDialogHighRes(
            this.desktopZoomOpenImage,
            this.desktopZoomOpenIndex,
            this.desktopZoomLoadToken,
            3840
          );
        }
      }
      resetDesktopZoom() {
        this.desktopZoom = 1;
        this.desktopPanX = 0;
        this.desktopPanY = 0;
        this.renderDesktopZoom();
      }
      startDesktopDrag(event) {
        if (event.button !== 0 || this.desktopZoom <= 1 || !this.desktopDialogViewport) return;
        event.preventDefault();
        this.desktopDrag = {
          pointerId: event.pointerId,
          startX: event.clientX,
          startY: event.clientY,
          originX: this.desktopPanX,
          originY: this.desktopPanY
        };
        this.desktopDialogViewport.dataset.dragging = 'true';
        this.desktopDialogViewport.setPointerCapture(event.pointerId);
      }
      moveDesktopDrag(event) {
        if (!this.desktopDrag || event.pointerId !== this.desktopDrag.pointerId) return;
        this.desktopPanX = this.desktopDrag.originX + event.clientX - this.desktopDrag.startX;
        this.desktopPanY = this.desktopDrag.originY + event.clientY - this.desktopDrag.startY;
        this.renderDesktopZoom();
      }
      endDesktopDrag(event) {
        if (!this.desktopDrag || event.pointerId !== this.desktopDrag.pointerId || !this.desktopDialogViewport) return;
        if (this.desktopDialogViewport.hasPointerCapture(event.pointerId)) {
          this.desktopDialogViewport.releasePointerCapture(event.pointerId);
        }
        this.desktopDrag = null;
        this.desktopDialogViewport.dataset.dragging = 'false';
        if (this.desktopZoomOpenImage && this.desktopMediaDialog?.open) {
          const desiredWidth =
            this.desktopZoom >= 2.25
              ? 3840
              : this.getDesktopDialogImageWidth();
          if (this.desktopDialogAppliedWidth < desiredWidth) {
            void this.loadDesktopDialogHighRes(
              this.desktopZoomOpenImage,
              this.desktopZoomOpenIndex,
              this.desktopZoomLoadToken,
              desiredWidth
            );
          }
        }
      }
      handleDesktopDialogKeydown(event) {
        if (event.key === '+' || event.key === '=') {
          event.preventDefault();
          this.setDesktopZoom(this.desktopZoom + 0.25);
          return;
        }
        if (event.key === '-') {
          event.preventDefault();
          this.setDesktopZoom(this.desktopZoom - 0.25);
          return;
        }
        if (event.key === '0') {
          event.preventDefault();
          this.resetDesktopZoom();
          return;
        }
        if (this.desktopZoom <= 1) return;
        if (!['ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown'].includes(event.key)) return;
        event.preventDefault();
        const step = 42;
        if (event.key === 'ArrowLeft') this.desktopPanX += step;
        if (event.key === 'ArrowRight') this.desktopPanX -= step;
        if (event.key === 'ArrowUp') this.desktopPanY += step;
        if (event.key === 'ArrowDown') this.desktopPanY -= step;
        this.renderDesktopZoom();
      }
      toggleSizeGuide(forceOpen) {
        if (
          !this.sizeGuideTrigger ||
          !this.sizeGuidePanel ||
          !this.sizeGuideDetails
        ) {
          return;
        }
        const shouldOpen =
          typeof forceOpen === 'boolean'
            ? forceOpen
            : this.sizeGuidePanel.hidden;
        this.sizeGuidePanel.hidden = !shouldOpen;
        this.sizeGuideDetails.open = shouldOpen;
        this.sizeGuideTrigger.setAttribute(
          'aria-expanded',
          String(shouldOpen)
        );
        if (!shouldOpen) return;
        window.requestAnimationFrame(() => {
          this.sizeGuidePanel.scrollIntoView({
            block: 'nearest',
            behavior: this.reducedMotion.matches ? 'auto' : 'smooth'
          });
        });
      }
      randomizePairCandidate() {
        if (!this.pairCandidates.length) return;
        let randomValue = Math.random();
        if (window.crypto?.getRandomValues) {
          const randomBuffer = new Uint32Array(1);
          window.crypto.getRandomValues(randomBuffer);
          randomValue = randomBuffer[0] / 4294967296;
        }
        const activeIndex = Math.min(
          this.pairCandidates.length - 1,
          Math.floor(randomValue * this.pairCandidates.length)
        );
        this.pairCandidates.forEach((candidate, index) => {
          candidate.hidden = index !== activeIndex;
        });
      }
      setPairOpen(shouldOpen, { scroll = false, announce = false } = {}) {
        if (!this.pairTrigger || !this.pairReveal) return;
        this.pairTrigger.setAttribute('aria-expanded', String(shouldOpen));
        this.pairReveal.setAttribute('aria-hidden', String(!shouldOpen));
        if (shouldOpen) {
          this.pairReveal.removeAttribute('inert');
        } else {
          this.pairReveal.setAttribute('inert', '');
        }
        if (announce && this.liveStatus) {
          this.liveStatus.textContent = 'Complete the look opened.';
        }
        if (!shouldOpen || !scroll) return;
        window.setTimeout(() => {
          this.detailsScroll?.scrollTo({
            top: this.detailsScroll.scrollHeight,
            behavior: this.reducedMotion.matches ? 'auto' : 'smooth'
          });
        }, this.reducedMotion.matches ? 0 : 280);
      }
      bindPairAutoOpenObserver() {
        if (
          !this.detailsScroll ||
          !this.pairTrigger ||
          !('IntersectionObserver' in window)
        ) {
          return;
        }
        this.pairObserver?.disconnect();
        this.pairObserver = new IntersectionObserver(
          (entries) => {
            const triggerEntry = entries.find(
              (entry) => entry.target === this.pairTrigger
            );
            if (!triggerEntry?.isIntersecting || triggerEntry.intersectionRatio < 0.75) {
              return;
            }
            this.schedulePairAutoOpen();
          },
          {
            root: this.detailsScroll,
            threshold: [0.75, 1]
          }
        );
        this.pairObserver.observe(this.pairTrigger);
      }
      schedulePairAutoOpen() {
        if (
          !this.detailsScroll ||
          !this.pairTrigger ||
          this.pairUserInteracted ||
          this.pairAutoOpened ||
          this.pairTrigger.getAttribute('aria-expanded') === 'true'
        ) {
          return;
        }
        window.cancelAnimationFrame(this.pairScrollFrame);
        this.pairScrollFrame = window.requestAnimationFrame(() => {
          this.pairScrollFrame = 0;
          if (
            this.mobileMedia.matches &&
            this.verticalSlides?.clientHeight > 0 &&
            this.verticalSlides.scrollTop < this.verticalSlides.clientHeight * 0.45
          ) {
            return;
          }
          const distanceFromBottom =
            this.detailsScroll.scrollHeight -
            this.detailsScroll.clientHeight -
            this.detailsScroll.scrollTop;
          if (distanceFromBottom > 64) return;
          this.pairAutoOpened = true;
          this.setPairOpen(true, { scroll: true, announce: true });
        });
      }
      hydrateMediaThumbnail(image) {
        const source = image?.dataset.mediaThumbnailSrc;
        if (!source) return;
        image.src = source;
        delete image.dataset.mediaThumbnailSrc;
        this.mediaThumbnailObserver?.unobserve(image);
      }
      activateMediaThumbnailHydration() {
        this.mediaThumbnailHydrationQueued = false;
        this.mediaThumbnailIdle = 0;
        this.mediaThumbnailTimer = 0;
        if (!(this.mobileMedia.matches || this.desktopMedia.matches) || !this.mediaPagination) return;
        const pendingThumbnails = this.mediaThumbnails.filter(
          (image) => image.dataset.mediaThumbnailSrc
        );
        if (!pendingThumbnails.length) return;
        if (!('IntersectionObserver' in window)) {
          pendingThumbnails.slice(0, 8).forEach((image) =>
            this.hydrateMediaThumbnail(image)
          );
          return;
        }
        this.mediaThumbnailObserver?.disconnect();
        this.mediaThumbnailObserver = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                this.hydrateMediaThumbnail(entry.target);
              }
            });
          },
          {
            root: this.mediaPagination,
            rootMargin: '0px 112px',
            threshold: 0.01
          }
        );
        pendingThumbnails.forEach((image) =>
          this.mediaThumbnailObserver.observe(image)
        );
      }
      scheduleMediaThumbnailHydration() {
        if (
          !(this.mobileMedia.matches || this.desktopMedia.matches) ||
          !this.mediaPagination ||
          !this.mediaThumbnails.some(
            (image) => image.dataset.mediaThumbnailSrc
          ) ||
          this.mediaThumbnailObserver ||
          this.mediaThumbnailHydrationQueued ||
          this.mediaThumbnailWaitingForHero
        ) {
          return;
        }
        const queueHydration = () => {
          this.mediaThumbnailWaitingForHero = false;
          if (!this.isConnected || !(this.mobileMedia.matches || this.desktopMedia.matches)) return;
          this.mediaThumbnailHydrationQueued = true;
          if ('requestIdleCallback' in window) {
            this.mediaThumbnailIdle = window.requestIdleCallback(
              () => this.activateMediaThumbnailHydration(),
              { timeout: 1200 }
            );
            return;
          }
          this.mediaThumbnailTimer = window.setTimeout(
            () => this.activateMediaThumbnailHydration(),
            240
          );
        };
        if (
          this.sharedHero &&
          !this.isGalleryImageDrawable(this.sharedHero)
        ) {
          this.mediaThumbnailWaitingForHero = true;
          this.sharedHero.addEventListener('load', queueHydration, {
            once: true,
            signal: this.sharedLifecycle.signal
          });
          this.sharedHero.addEventListener('error', queueHydration, {
            once: true,
            signal: this.sharedLifecycle.signal
          });
          return;
        }
        queueHydration();
      }
      disconnectMediaThumbnailHydration() {
        this.mediaThumbnailObserver?.disconnect();
        this.mediaThumbnailObserver = null;
        if (this.mediaThumbnailIdle && 'cancelIdleCallback' in window) {
          window.cancelIdleCallback(this.mediaThumbnailIdle);
        }
        window.clearTimeout(this.mediaThumbnailTimer);
        this.mediaThumbnailIdle = 0;
        this.mediaThumbnailTimer = 0;
        this.mediaThumbnailHydrationQueued = false;
        this.mediaThumbnailWaitingForHero = false;
      }
      centerActiveMediaThumbnail(index) {
        const rail = this.querySelector('tbhnp-product-media-rail');
        if (rail?.active) {
          rail.syncActive(index);
          return;
        }
        if (!this.mobileMedia.matches || !this.mediaPagination) return;
        const activeThumbnail = this.mediaPages[index];
        if (!activeThumbnail) return;
        const maxScrollLeft = Math.max(
          0,
          this.mediaPagination.scrollWidth - this.mediaPagination.clientWidth
        );
        const targetLeft = Math.max(
          0,
          Math.min(
            maxScrollLeft,
            activeThumbnail.offsetLeft -
              (this.mediaPagination.clientWidth - activeThumbnail.offsetWidth) /
                2
          )
        );
        this.mediaPagination.scrollTo({
          left: targetLeft,
          behavior: this.reducedMotion.matches ? 'auto' : 'smooth'
        });
      }
      setActiveMedia(index, moveTrack, eagerTarget = false, selectionFade = false) {
        if (!this.mediaSlides.length) return;
        if (moveTrack && this.galleryTrack && this.programmaticMediaScroll) {
          this.cancelProgrammaticMediaScroll(true, true);
        }
        const previousIndex =
          moveTrack && this.galleryTrack
            ? this.mediaIndexFromScroll()
            : this.activeMediaIndex;
        const nextIndex = Math.max(
          0,
          Math.min(index, this.mediaSlides.length - 1)
        );
        this.activeMediaIndex = nextIndex;
        this.hydrateMediaNeighborhood(nextIndex, {
          eagerTarget: eagerTarget || moveTrack
        });
        if (previousIndex !== nextIndex) {
          this.mediaPages[previousIndex]?.setAttribute('aria-current', 'false');
        }
        this.mediaPages[nextIndex]?.setAttribute('aria-current', 'true');
        this.hydrateMediaThumbnail(this.mediaThumbnails[nextIndex]);
        this.centerActiveMediaThumbnail(nextIndex);
        if (!moveTrack || !this.galleryTrack) return;
        const target = this.mediaSlides[nextIndex];
        const rail = this.querySelector('tbhnp-product-media-rail');
        const visualIndex = (sourceIndex) => rail?.active
          ? rail.items.findIndex(item => item.index === sourceIndex)
          : sourceIndex;
        const distance = Math.abs(visualIndex(nextIndex) - visualIndex(previousIndex));
        const behavior =
          this.reducedMotion.matches || selectionFade || distance > 1 ? 'auto' : 'smooth';
        this.beginProgrammaticMediaScroll(
          nextIndex,
          target.offsetLeft,
          behavior
        );
      }
      galleryImageAt(index) {
        return this.mediaSlides[index]?.querySelector(
          '[data-gallery-deferred-image]'
        );
      }
      galleryPreviewAt(index) {
        return this.mediaSlides[index]?.querySelector(
          '[data-gallery-preview-image]'
        );
      }
      isGalleryImageDrawable(image) {
        if (!image?.complete || image.naturalWidth <= 1) return false;
        const source = image.currentSrc || image.src || '';
        return Boolean(source) && !source.startsWith('data:');
      }
      isGallerySlideDrawable(index) {
        const slide = this.mediaSlides[index];
        if (!slide) return false;
        const preview = this.galleryPreviewAt(index);
        const image =
          this.galleryImageAt(index) ||
          slide.querySelector(
            '.tbhnp-mobile-pdp__media-image:not([data-gallery-preview-image])'
          );
        if (!image && !preview) return true;
        return (
          this.isGalleryImageDrawable(image) ||
          this.isGalleryImageDrawable(preview)
        );
      }
      markGalleryPreviewReady(index, preview = this.galleryPreviewAt(index)) {
        if (
          preview?.dataset.galleryPreviewLoaded !== 'true' ||
          !this.isGalleryImageDrawable(preview)
        ) {
          return;
        }
        preview.dataset.galleryPreviewReady = 'true';
        const image = this.galleryImageAt(index);
        if (
          this.mobileMedia.matches &&
          index === this.activeMediaIndex &&
          image?.dataset.galleryUpgradePending === 'true'
        ) {
          image.dataset.galleryUpgradePending = 'false';
          this.hydrateGalleryImage(index, { eager: true });
        }
        this.preparePredictedGalleryPreview(index);
      }
      markGalleryPreviewFailed(index, preview = this.galleryPreviewAt(index)) {
        if (preview?.dataset.galleryPreviewLoaded !== 'true') return;
        preview.dataset.galleryPreviewFailed = 'true';
        const image = this.galleryImageAt(index);
        if (
          this.mobileMedia.matches &&
          index === this.activeMediaIndex &&
          image?.dataset.galleryUpgradePending === 'true'
        ) {
          image.dataset.galleryUpgradePending = 'false';
          this.hydrateGalleryImage(index, { eager: true });
        }
      }
      markGalleryImageReady(index, image = this.galleryImageAt(index)) {
        if (
          image?.dataset.galleryLoaded !== 'true' ||
          image.dataset.galleryReady === 'true' ||
          !this.isGalleryImageDrawable(image)
        ) {
          return;
        }
        image.dataset.galleryReady = 'true';
        const preview = this.galleryPreviewAt(index);
        if (preview) {
          window.requestAnimationFrame(() => {
            window.requestAnimationFrame(() => {
              if (
                !this.isConnected ||
                image.dataset.galleryReady !== 'true' ||
                !this.isGalleryImageDrawable(image)
              ) {
                return;
              }
              preview.hidden = true;
            });
          });
        }
        this.preparePredictedGalleryPreview(index);
      }
      hydrateGalleryPreview(index, { priority = 'auto' } = {}) {
        if (!this.mobileMedia.matches) return;
        const image = this.galleryImageAt(index);
        const preview = this.galleryPreviewAt(index);
        if (!preview || image?.dataset.galleryReady === 'true') return;
        preview.loading = 'eager';
        if (priority === 'high' || preview.fetchPriority !== 'high') {
          preview.fetchPriority = priority;
        }
        if (preview.dataset.galleryPreviewLoaded !== 'true') {
          if (preview.dataset.galleryPreviewSrc) {
            preview.src = preview.dataset.galleryPreviewSrc;
          }
          preview.dataset.galleryPreviewLoaded = 'true';
        }
        if (this.isGalleryImageDrawable(preview)) {
          window.queueMicrotask(() =>
            this.markGalleryPreviewReady(index, preview)
          );
        }
      }
      preparePredictedGalleryPreview(index) {
        if (
          !this.mobileMedia.matches ||
          index !== this.activeMediaIndex ||
          index !== this.galleryPredictedFromIndex ||
          !this.isGallerySlideDrawable(index)
        ) {
          return;
        }
        const image = this.galleryImageAt(index);
        this.hydrateGalleryPreview(this.adjacentGalleryIndex(index, 1), {
          priority:
            !image || image.dataset.galleryReady === 'true'
              ? 'high'
              : 'auto'
        });
      }
      prioritizeGalleryScrollDirection() {
        if (
          !this.mobileMedia.matches ||
          !this.galleryTrack ||
          !this.galleryGestureActive
        ) {
          return;
        }
        const scrollLeft = this.galleryTrack.scrollLeft;
        const delta = scrollLeft - this.galleryLastScrollLeft;
        this.galleryLastScrollLeft = scrollLeft;
        if (Math.abs(delta) < 1) return;
        this.hydrateGalleryPreview(
          this.adjacentGalleryIndex(this.activeMediaIndex, Math.sign(delta)),
          { priority: 'high' }
        );
      }
      hydrateGalleryImage(index, { eager = false } = {}) {
        const image = this.mediaSlides[index]?.querySelector(
          '[data-gallery-deferred-image]'
        );
        if (!image) return;
        if (eager) {
          image.loading = 'eager';
          image.fetchPriority = 'high';
        }
        if (image.dataset.galleryLoaded === 'true') return;
        if (image.dataset.gallerySrcset) {
          image.srcset = image.dataset.gallerySrcset;
        }
        if (image.dataset.gallerySrc) {
          image.src = image.dataset.gallerySrc;
        }
        image.dataset.galleryLoaded = 'true';
        if (this.isGalleryImageDrawable(image)) {
          window.queueMicrotask(() => this.markGalleryImageReady(index, image));
        }
      }
      hydrateMediaNeighborhood(index, { eagerTarget = false } = {}) {
        if (!this.mobileMedia.matches && !this.desktopMedia.matches) return;
        if (this.mobileMedia.matches) {
          this.galleryPredictedFromIndex = index;
          this.hydrateGalleryPreview(index, {
            priority: eagerTarget ? 'high' : 'auto'
          });
          const image = this.galleryImageAt(index);
          const preview = this.galleryPreviewAt(index);
          if (
            image &&
            preview &&
            preview.dataset.galleryPreviewReady !== 'true' &&
            preview.dataset.galleryPreviewFailed !== 'true'
          ) {
            image.dataset.galleryUpgradePending = 'true';
            if (eagerTarget) {
              image.loading = 'eager';
              image.fetchPriority = 'high';
            }
          } else {
            this.hydrateGalleryImage(index, { eager: eagerTarget });
          }
          this.preparePredictedGalleryPreview(index);
          return;
        }
        [index - 1, index, index + 1].forEach((mediaIndex) => {
          if (mediaIndex < 0 || mediaIndex >= this.mediaSlides.length) return;
          this.hydrateGalleryImage(mediaIndex, {
            eager: eagerTarget && mediaIndex === index
          });
        });
      }
      mediaIndexFromScroll() {
        if (!this.galleryTrack || !this.mediaSlides.length) return 0;
        const visualIndex = Math.max(
          0,
          Math.min(
            this.mediaSlides.length - 1,
            Math.round(
              this.galleryTrack.scrollLeft /
                Math.max(this.galleryTrack.clientWidth, 1)
            )
          )
        );
        const rail = this.querySelector('tbhnp-product-media-rail');
        return rail?.active ? (rail.items[visualIndex]?.index ?? visualIndex) : visualIndex;
      }
      adjacentGalleryIndex(index, direction) {
        const rail = this.querySelector('tbhnp-product-media-rail');
        if (!rail?.active) return index + direction;
        const position = rail.items.findIndex(item => item.index === index);
        return rail.items[position + direction]?.index ?? -1;
      }
      beginProgrammaticMediaScroll(targetIndex, targetLeft, behavior) {
        if (!this.galleryTrack) return;
        window.cancelAnimationFrame(this.scrollFrame);
        this.scrollFrame = 0;
        this.cancelProgrammaticMediaScroll(false, true);
        const generation = ++this.mediaScrollGeneration;
        this.programmaticMediaScroll = {
          generation,
          targetIndex,
          targetLeft,
          lastLeft: null,
          stableFrames: 0
        };
        if (behavior === 'auto') {
          const inlineScrollBehavior = this.galleryTrack.style.scrollBehavior;
          this.galleryTrack.style.scrollBehavior = 'auto';
          this.galleryTrack.scrollTo({ left: targetLeft, behavior: 'auto' });
          this.galleryTrack.style.scrollBehavior = inlineScrollBehavior;
        } else {
          this.galleryTrack.scrollTo({ left: targetLeft, behavior: 'smooth' });
        }
        this.scheduleProgrammaticMediaSettle(generation);
      }
      scheduleProgrammaticMediaSettle(generation) {
        window.cancelAnimationFrame(this.programmaticMediaSettleFrame);
        window.clearTimeout(this.programmaticMediaSettleTimer);
        const checkPosition = () => {
          const state = this.programmaticMediaScroll;
          if (!state || state.generation !== generation || !this.galleryTrack) {
            return;
          }
          const currentLeft = this.galleryTrack.scrollLeft;
          const reachedTarget = Math.abs(currentLeft - state.targetLeft) <= 1;
          if (
            reachedTarget ||
            (state.lastLeft !== null && Math.abs(currentLeft - state.lastLeft) <= 0.25)
          ) {
            state.stableFrames += 1;
          } else {
            state.stableFrames = 0;
          }
          state.lastLeft = currentLeft;
          if (state.stableFrames >= 3) {
            this.finishProgrammaticMediaScroll(generation);
            return;
          }
          this.programmaticMediaSettleFrame = window.requestAnimationFrame(
            checkPosition
          );
        };
        this.programmaticMediaSettleFrame = window.requestAnimationFrame(
          checkPosition
        );
        this.programmaticMediaSettleTimer = window.setTimeout(
          () => this.finishProgrammaticMediaScroll(generation),
          1200
        );
      }
      finishProgrammaticMediaScroll(generation) {
        const state = this.programmaticMediaScroll;
        if (!state || state.generation !== generation) return;
        window.cancelAnimationFrame(this.programmaticMediaSettleFrame);
        window.clearTimeout(this.programmaticMediaSettleTimer);
        this.programmaticMediaSettleFrame = 0;
        this.programmaticMediaSettleTimer = 0;
        this.programmaticMediaScroll = null;
        this.galleryLastScrollLeft = this.galleryTrack?.scrollLeft || 0;
        this.setActiveMedia(this.mediaIndexFromScroll(), false, true);
      }
      cancelProgrammaticMediaScroll(commitActual = true, stopMotion = false) {
        const hadProgrammaticScroll = Boolean(this.programmaticMediaScroll);
        this.mediaScrollGeneration += 1;
        window.cancelAnimationFrame(this.programmaticMediaSettleFrame);
        window.clearTimeout(this.programmaticMediaSettleTimer);
        this.programmaticMediaSettleFrame = 0;
        this.programmaticMediaSettleTimer = 0;
        this.programmaticMediaScroll = null;
        this.galleryLastScrollLeft = this.galleryTrack?.scrollLeft || 0;
        if (stopMotion && hadProgrammaticScroll && this.galleryTrack) {
          const currentLeft = this.galleryTrack.scrollLeft;
          const inlineScrollBehavior = this.galleryTrack.style.scrollBehavior;
          this.galleryTrack.style.scrollBehavior = 'auto';
          this.galleryTrack.scrollTo({ left: currentLeft, behavior: 'auto' });
          this.galleryTrack.style.scrollBehavior = inlineScrollBehavior;
        }
        if (commitActual && hadProgrammaticScroll) {
          this.setActiveMedia(this.mediaIndexFromScroll(), false, true);
        }
      }
      syncMediaFromScroll() {
        if (!this.galleryTrack || !this.mediaSlides.length) return;
        if (this.programmaticMediaScroll) return;
        this.prioritizeGalleryScrollDirection();
        window.cancelAnimationFrame(this.scrollFrame);
        this.scrollFrame = window.requestAnimationFrame(() => {
          this.scrollFrame = 0;
          const closestIndex = this.mediaIndexFromScroll();
          if (closestIndex !== this.activeMediaIndex) {
            this.setActiveMedia(closestIndex, false, true);
          } else {
            this.hydrateMediaNeighborhood(closestIndex, {
              eagerTarget: true
            });
          }
        });
      }
      selectOption(button, { preserveMedia = false } = {}) {
        if (button.disabled || this.busy) return;
        const optionIndex = Number(button.dataset.optionIndex);
        const optionValue = button.dataset.optionValue;
        const candidateOptions = [...this.selectedOptions];
        candidateOptions[optionIndex] = optionValue;
        let nextVariant = this.findVariant(candidateOptions);
        if (!nextVariant) {
          nextVariant =
            this.variants.find(
              (variant) =>
                variant.options[optionIndex] === optionValue && variant.available
            ) ||
            this.variants.find(
              (variant) => variant.options[optionIndex] === optionValue
            ) ||
            null;
        }
        this.selectedOptions = nextVariant
          ? [...nextVariant.options]
          : candidateOptions;
        this.variant = nextVariant;
        this.clearError();
        this.renderVariant(true, preserveMedia);
      }
      syncBuyClearance() { return window.TBHNPPurchaseControls.syncBuyClearance(this); }
      recommendedSizeVariant(size) { return window.TBHNPPurchaseControls.recommendedSizeVariant(this, size); }
      applyRecommendedSize(size) { return window.TBHNPPurchaseControls.applyRecommendedSize(this, size); }
      findVariant(options) {
        return (
          this.variants.find((variant) =>
            variant.options.every(
              (optionValue, index) => optionValue === options[index]
            )
          ) || null
        );
      }
      renderVariant(announce, preserveMedia = false) {
        const mediaKey = String(this.variant?.featured_media?.id || this.variant?.featured_image?.id || this.variant?.id || '');
        const fadeMedia = announce && !preserveMedia && mediaKey !== this.lastMotionMediaId;
        this.lastMotionMediaId = mediaKey;
        this.syncOptionButtons();
        this.selectionMotions?.forEach(motion => motion.update(announce));
        this.syncOptionLabels();
        this.syncPrice();
        this.syncCurrentImage(fadeMedia);
        if (!preserveMedia) this.syncGalleryToVariant(announce, fadeMedia);
        this.syncAddButton();
        this.syncAddButtonGlass();
        if (this.buySelection) this.buySelection.textContent = this.variant?.title || this.translate('unavailable');
        this.dispatchEvent(new CustomEvent('tbhnp:selection-change'));
        if (!this.variant) {
          if (announce) this.announce(this.translate('unavailable'));
          return;
        }
        this.updateVariantURL();
        if (announce) {
          const status = this.variant.available
            ? this.translate('available')
            : this.translate('soldOutStatus');
          this.announce(
            this.translate('variantAnnouncement', {
              __TITLE__: this.variant.title,
              __STATUS__: status
            })
          );
        }
      }
      syncOptionButtons() {
        this.optionButtons.forEach((button) => {
          const optionIndex = Number(button.dataset.optionIndex);
          const optionValue = button.dataset.optionValue;
          const candidate = [...this.selectedOptions];
          candidate[optionIndex] = optionValue;
          const matches = this.variants.filter((variant) =>
            variant.options.every(
              (value, index) =>
                index === optionIndex || value === candidate[index]
            )
          );
          const exists = matches.some(
            (variant) => variant.options[optionIndex] === optionValue
          );
          const available = matches.some(
            (variant) =>
              variant.options[optionIndex] === optionValue && variant.available
          );
          const selected =
            this.selectedOptions[optionIndex] === optionValue;
          button.disabled = !exists;
          button.setAttribute('aria-disabled', String(!exists));
          button.setAttribute('aria-checked', String(selected));
          button.dataset.soldOut = String(exists && !available);
        });
        this.updateRovingTabIndexes();
      }
      syncOptionLabels() {
        this.optionLabels.forEach((label) => {
          const index = Number(label.dataset.optionValueLabel);
          label.textContent = this.selectedOptions[index] || this.translate('select');
        });
      }
      syncPrice() {
        this.pullbarMeasureDirty = true;
        this.scheduleVerticalStack();
        if (!this.variant) {
          this.compareElement?.setAttribute('hidden', '');
          this.saleLabel?.setAttribute('hidden', '');
          return;
        }
        const price = this.variantPrices[String(this.variant.id)] || {};
        if (this.priceElement) {
          this.priceElement.textContent = price.price || '';
        }
        if (this.addPrice) {
          this.addPrice.textContent = price.price || '';
        }
        if (price.compareAt) {
          if (this.compareElement) {
            this.compareElement.textContent = price.compareAt;
            this.compareElement.removeAttribute('hidden');
          }
          this.saleLabel?.removeAttribute('hidden');
        } else {
          this.compareElement?.setAttribute('hidden', '');
          this.saleLabel?.setAttribute('hidden', '');
        }
      }
    fadeVariantImage(image, reveal) {
      if (!image || !image.getClientRects().length) {
        reveal?.();
        return;
      }
      const previous = this.mediaFadeStates.get(image);
      previous?.animation?.cancel();
      const state = { mediaId: this.lastMotionMediaId };
      this.mediaFadeStates.set(image, state);
      const forget = () => {
        if (this.mediaFadeStates.get(image) === state) this.mediaFadeStates.delete(image);
      };
      const show = () => {
        if (!this.isConnected || this.mediaFadeStates.get(image) !== state || this.lastMotionMediaId !== state.mediaId) {
          forget();
          return;
        }
        reveal?.();
        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
          forget();
          return;
        }
        state.animation = image.animate([{ opacity: .2 }, { opacity: 1 }], { duration: 320, easing: 'cubic-bezier(.2,.65,.3,1)' });
        state.animation.finished.then(forget).catch(() => {});
      };
      if (image.complete && image.naturalWidth) show();
      else {
        image.loading = 'eager';
        image.decode().then(show).catch(forget);
      }
    }

      syncCurrentImage(fadeMedia = false) {
        if (!this.currentImage || !this.variant) return;
        let variantImage =
          this.variant.featured_image ||
          this.variant.featured_media?.preview_image ||
          null;
        if (!variantImage && this.colorOptionIndex >= 0) {
          const selectedColor = this.selectedOptions[this.colorOptionIndex];
          const colorVariant = this.variants.find(
            (variant) =>
              variant.options[this.colorOptionIndex] === selectedColor &&
              (variant.featured_image ||
                variant.featured_media?.preview_image)
          );
          variantImage =
            colorVariant?.featured_image ||
            colorVariant?.featured_media?.preview_image ||
            null;
        }
        const imageSource =
          variantImage?.src ||
          variantImage?.url ||
          variantImage?.preview_image?.src ||
          this.dataset.fallbackImage ||
          '';
        if (imageSource) {
          const normalizeImageSource = (source) => {
            if (!source) return '';
            try {
              const normalizedUrl = new URL(source, window.location.origin);
              normalizedUrl.searchParams.delete('width');
              return normalizedUrl.toString();
            } catch (error) {
              return source;
            }
          };
          const currentImageSource =
            this.currentImage.dataset.currentVariantSource ||
            this.currentImage.currentSrc ||
            this.currentImage.src ||
            '';
          if (
            normalizeImageSource(currentImageSource) !==
            normalizeImageSource(imageSource)
          ) {
            let displayImageSource = imageSource;
            let displayImageSrcset = '';
            try {
              const displayImageUrl = new URL(imageSource, window.location.origin);
              const responsiveWidths = [180, 240, 360, 480, 720, 900];
              displayImageSrcset = responsiveWidths
                .map((width) => {
                  const candidateUrl = new URL(displayImageUrl);
                  candidateUrl.searchParams.set('width', String(width));
                  return `${candidateUrl.toString()} ${width}w`;
                })
                .join(', ');
              displayImageUrl.searchParams.set('width', '900');
              displayImageSource = displayImageUrl.toString();
            } catch (error) {
              // Keep the original variant image URL when it cannot be normalized.
            }
            if (displayImageSrcset) {
              this.currentImage.srcset = displayImageSrcset;
              this.currentImage.sizes = '(max-width: 350px) 104px, 132px';
            } else {
              this.currentImage.removeAttribute('srcset');
            }
            this.currentImage.src = displayImageSource;
            this.currentImage.dataset.currentVariantSource = imageSource;
            if (fadeMedia) this.fadeVariantImage(this.currentImage);
          }
          this.currentImage.alt =
            variantImage?.alt ||
            this.translate('currentSelection', { __TITLE__: this.variant.title });
        }
        if (this.currentLabel) {
          this.currentLabel.textContent =
            this.colorOptionIndex >= 0
              ? this.selectedOptions[this.colorOptionIndex] || this.variant.title
              : this.variant.title;
        }
      }
      syncGalleryToVariant(moveTrack, fadeMedia = false) {
        if (!this.variant || !this.mediaSlides.length) {
          this.setActiveMedia(0, moveTrack);
          return;
        }
        const mediaId =
          this.variant.featured_media?.id ||
          this.variant.featured_image?.id ||
          null;
        const mediaIndex = mediaId
          ? this.mediaSlides.findIndex(
              (slide) => String(slide.dataset.mediaId) === String(mediaId)
            )
          : -1;
        if (fadeMedia && moveTrack && mediaIndex >= 0) {
          this.hydrateGalleryImage(mediaIndex, { eager: true });
          const image = this.galleryImageAt(mediaIndex) || this.mediaSlides[mediaIndex].querySelector('img');
          this.fadeVariantImage(image, () => this.setActiveMedia(mediaIndex, true, true, true));
        } else {
          this.setActiveMedia(mediaIndex >= 0 ? mediaIndex : 0, moveTrack);
        }
      }
      syncAddButtonGlass() {
        if (!this.addButton) return;
        const selected = this.optionButtons.find((button) =>
          Number(button.dataset.optionIndex) === this.colorOptionIndex &&
          button.dataset.optionValue === this.selectedOptions[this.colorOptionIndex]
        );
        const swatch = selected?.querySelector('.tbhnp-mobile-pdp__swatch');
        const material = swatch ? window.getComputedStyle(swatch) : null;
        const tint = material?.backgroundColor || 'rgb(190, 190, 185)';
        const texture = this.addButton.querySelector('.tbhnp-mobile-pdp__buy-texture');
        this.addButton.style.setProperty('--tbhnp-buy-tint', tint);
        if (texture) {
          texture.style.backgroundImage = material?.backgroundImage || 'none';
          texture.style.backgroundSize = material?.backgroundSize || 'cover';
          texture.style.backgroundPosition = material?.backgroundPosition || 'center';
          texture.style.backgroundRepeat = 'no-repeat';
          texture.style.transform = `scale(${this.addButton.clientWidth / 24}, ${this.addButton.clientHeight / 24})`;
        }
        this.addButton.style.setProperty('--tbhnp-buy-ink', '#171717');
      }
      syncAddButton() {
        if (!this.addButton || this.busy) return;
        const available = Boolean(this.variant?.available);
        this.addButton.disabled = !available;
        this.addButton.removeAttribute('aria-busy');
        if (this.addLabel) {
          this.addLabel.textContent = available
            ? this.translate('addToCart')
            : this.translate('soldOut');
        }
      }
      updateVariantURL() {
        if (!this.variant || !window.history?.replaceState) return;
        const url = new URL(window.location.href);
        url.searchParams.set('variant', String(this.variant.id));
        window.history.replaceState({}, '', url);
      }
      handleOptionKeydown(event, currentButton) {
        const supportedKeys = [
          'ArrowRight',
          'ArrowDown',
          'ArrowLeft',
          'ArrowUp',
          'Home',
          'End'
        ];
        if (!supportedKeys.includes(event.key)) return;
        const optionIndex = currentButton.dataset.optionIndex;
        const buttons = this.optionButtons.filter(
          (button) =>
            button.dataset.optionIndex === optionIndex && !button.disabled
        );
        if (!buttons.length) return;
        event.preventDefault();
        const currentIndex = Math.max(0, buttons.indexOf(currentButton));
        let nextIndex = currentIndex;
        if (event.key === 'Home') nextIndex = 0;
        if (event.key === 'End') nextIndex = buttons.length - 1;
        if (event.key === 'ArrowRight' || event.key === 'ArrowDown') {
          nextIndex = (currentIndex + 1) % buttons.length;
        }
        if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') {
          nextIndex = (currentIndex - 1 + buttons.length) % buttons.length;
        }
        const nextButton = buttons[nextIndex];
        this.selectOption(nextButton);
        nextButton.focus();
      }
      updateRovingTabIndexes() {
        const optionIndexes = [
          ...new Set(
            this.optionButtons.map((button) => button.dataset.optionIndex)
          )
        ];
        optionIndexes.forEach((optionIndex) => {
          const buttons = this.optionButtons.filter(
            (button) =>
              button.dataset.optionIndex === optionIndex && !button.disabled
          );
          const checked =
            buttons.find(
              (button) => button.getAttribute('aria-checked') === 'true'
            ) || buttons[0];
          buttons.forEach((button) => {
            button.tabIndex = button === checked ? 0 : -1;
          });
        });
      }
      getCartSectionIds() {
        const ids = [...document.querySelectorAll('cart-items-component')]
          .flatMap((component) => {
            const values = [
              component.dataset.sectionId,
              component.getAttribute('section-id'),
              component.dataset.sectionIds
            ];
            return values.flatMap((value) =>
              value ? value.split(',').map((item) => item.trim()) : []
            );
          })
          .filter(Boolean);
        return [...new Set(ids)];
      }
      async addToCart() {
        if (this.busy || !this.variant?.available || !this.addButton) return;
        this.busy = true;
        this.clearError();
        this.addButton.disabled = true;
        this.addButton.setAttribute('aria-busy', 'true');
        if (this.addLabel) this.addLabel.textContent = this.translate('adding');
        const variantId = Number(this.variant.id);
        const sectionIds = this.getCartSectionIds();
        const payload = {
          items: [{ id: variantId, quantity: 1 }]
        };
        if (sectionIds.length) {
          payload.sections = sectionIds;
          payload.sections_url = window.location.pathname;
        }
        const routesRoot = window.Shopify?.routes?.root || '/';
        let itemWasAdded = false;
        try {
          const addResponse = await fetch(`${routesRoot}cart/add.js`, {
            method: 'POST',
            credentials: 'same-origin',
            headers: {
              Accept: 'application/json',
              'Content-Type': 'application/json'
            },
            body: JSON.stringify(payload)
          });
          const addResult = await addResponse.json().catch(() => ({}));
          if (!addResponse.ok) {
            throw new Error(
              addResult.description ||
                addResult.message ||
                this.translate('addError')
            );
          }
          itemWasAdded = true;
          const cartResponse = await fetch(`${routesRoot}cart.js`, {
            method: 'GET',
            credentials: 'same-origin',
            headers: { Accept: 'application/json' }
          });
          if (!cartResponse.ok) {
            throw new Error(this.translate('cartRefreshError'));
          }
          const cart = await cartResponse.json();
          const sections = addResult.sections || {};
          this.dispatchEvent(
            new CustomEvent('cart:update', {
              bubbles: true,
              detail: {
                resource: cart,
                sourceId: this.id,
                data: {
                source: 'tbhnp-mobile-pdp',
                productId: this.productId,
                variantId,
                itemCount: cart.item_count,
                sections
              }
            }
            })
          );
          if (this.addLabel) this.addLabel.textContent = this.translate('added');
          this.announce(
            this.translate('addedAnnouncement', { __TITLE__: this.variant.title })
          );
          window.setTimeout(() => {
            this.busy = false;
            this.syncAddButton();
          }, 1400);
        } catch (error) {
          this.busy = false;
          this.showError(
            itemWasAdded
              ? this.translate('cartRefreshHelp')
              : error.message || this.translate('addError')
          );
          this.syncAddButton();
        }
      }
      showError(message) {
        if (!this.errorElement) return;
        this.errorElement.textContent = message;
        this.errorElement.hidden = false;
        this.announce(message);
      }
      clearError() {
        if (!this.errorElement) return;
        this.errorElement.textContent = '';
        this.errorElement.hidden = true;
      }
      announce(message) {
        if (this.liveStatus) this.liveStatus.textContent = message;
      }
    }
    customElements.define(elementName, TBHNPMobileProductSlide);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["tbhnp-product-discovery"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('tbhnp-product-discovery')) {
  customElements.define('tbhnp-product-discovery', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const signal = this.controller.signal;
      this.querySelectorAll('.tbhnp-discovery__rail').forEach(rail => {
        let origin = null;
        let moved = false;
        let suppressClick = false;
        rail.addEventListener('dragstart', event => event.preventDefault(), { signal });
        rail.addEventListener('pointerdown', event => {
          if (event.pointerType !== 'mouse' || event.button !== 0) return;
          origin = { x: event.clientX, scroll: rail.scrollLeft, pointer: event.pointerId };
          moved = false;
          suppressClick = false;
        }, { signal });
        rail.addEventListener('pointermove', event => {
          if (!origin) return;
          const distance = event.clientX - origin.x;
          if (!moved && Math.abs(distance) < 6) return;
          moved = true;
          rail.classList.add('is-dragging');
          rail.setPointerCapture(origin.pointer);
          rail.scrollLeft = origin.scroll - distance;
        }, { signal });
        const finish = () => {
          suppressClick = moved;
          origin = null;
          rail.classList.remove('is-dragging');
        };
        rail.addEventListener('pointerup', finish, { signal });
        rail.addEventListener('pointercancel', finish, { signal });
        rail.addEventListener('pointerleave', () => { if (!moved) origin = null; }, { signal });
        rail.addEventListener('click', event => {
          if (!suppressClick) return;
          event.preventDefault();
          event.stopPropagation();
          suppressClick = false;
        }, { capture: true, signal });
        rail.addEventListener('keydown', event => {
          if (event.target !== rail || !['ArrowLeft','ArrowRight','Home','End'].includes(event.key)) return;
          event.preventDefault();
          const step = rail.querySelector('.tbhnp-discovery__card')?.getBoundingClientRect().width + 10 || 150;
          const left = event.key === 'Home' ? 0 : event.key === 'End' ? rail.scrollWidth : rail.scrollLeft + (event.key === 'ArrowRight' ? step : -step);
          rail.scrollTo({ left, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
        }, { signal });
      });
    }
    disconnectedCallback() { this.controller?.abort(); }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["tbhnp-product-media-rail"] && !Shopify.designMode) return;
  try {
    (() => {
    const elementName = 'tbhnp-product-media-rail';
    if (customElements.get(elementName)) return;

    class TBHNPProductMediaRail extends HTMLElement {
      connectedCallback() {
        const generation = (this.generation || 0) + 1;
        this.generation = generation;
        customElements.whenDefined('tbhnp-mobile-product-slide').then(() => {
          if (!this.isConnected || this.generation !== generation) return;
          this.host = this.closest('tbhnp-mobile-product-slide');
          this.nav = this.host?.querySelector('.tbhnp-mobile-pdp__media-pagination');
          if (!this.nav) return;
          this.viewport = window.matchMedia('(max-width: 749px) and (orientation: portrait), (min-width: 750px) and (min-height: 521px)');
          this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
          this.onViewportChange = () => this.viewport.matches ? this.activate() : this.deactivate();
          this.onMotionChange = () => { if (this.active) this.layout(false); };
          this.viewport.addEventListener('change', this.onViewportChange);
          this.motion.addEventListener('change', this.onMotionChange);
          this.onViewportChange();
        });
      }

      disconnectedCallback() {
        this.generation = (this.generation || 0) + 1;
        this.viewport?.removeEventListener('change', this.onViewportChange);
        this.motion?.removeEventListener('change', this.onMotionChange);
        this.deactivate();
      }

      activate() {
        if (this.active || !this.nav || !this.isConnected) return;
        const buttons = [...this.nav.querySelectorAll('[data-media-page]')];
        if (!buttons.length) return;
        if (buttons.every(button => !button.dataset.railColour && (!button.dataset.railCategory || button.dataset.railCategory === 'images'))) return;
        this.mediaTrack = this.host.galleryTrack;
        if (!this.mediaTrack || buttons.length !== this.host.mediaSlides?.length) return;
        const initialSlide = this.host.mediaSlides[this.host.activeMediaIndex];
        this.host.cancelProgrammaticMediaScroll?.(false, true);
        this.originalMediaNodes = [...this.mediaTrack.childNodes];
        this.active = true;
        this.lifecycle = new AbortController();
        this.originalNodes = [...this.nav.childNodes];
        this.savedScroll = this.nav.scrollLeft;
        this.groups = [];
        this.items = [];
        this.byIndex = new Map();
        this.animated = [];
        this.openGroup = null;
        this.frame = 0;
        this.trackWidth = 0;
        this.targetWidth = 0;
        this.pointer = null;
        this.suppressClick = false;
        const categories = { product: 0, model: 1, details: 2, images: 3 };
        const groups = new Map();
        const savedAttributes = ['style', 'hidden', 'inert', 'tabindex', 'aria-hidden', 'aria-label', 'aria-expanded', 'data-rail-cover', 'data-rail-current-group'];

        buttons.forEach((el, position) => {
          const colour = el.dataset.railColour || '';
          const category = Object.hasOwn(categories, el.dataset.railCategory) ? el.dataset.railCategory : 'images';
          const key = JSON.stringify([colour, category]);
          if (!groups.has(key)) {
            const colourOrder = Number(el.dataset.railColourOrder);
            groups.set(key, {
              key, colour, category,
              order: Number.isFinite(colourOrder) && el.dataset.railColourOrder !== undefined ? colourOrder : 100000 + position,
              position,
              label: el.dataset.railLabel || this.nav.getAttribute('aria-label') || el.getAttribute('aria-label') || '',
              items: []
            });
          }
          const group = groups.get(key);
          const item = {
            el, group, index: Number(el.dataset.mediaPage), position: group.items.length,
            x: 0, tx: 0, v: 0, opacity: 0, targetOpacity: 0, opacityVelocity: 0,
            visible: false,
            original: savedAttributes.map(name => [name, el.getAttribute(name)])
          };
          group.items.push(item);
          this.items.push(item);
          this.byIndex.set(item.index, item);
        });

        this.groups = [...groups.values()].sort((a, b) => a.order - b.order || categories[a.category] - categories[b.category] || a.position - b.position);
        this.items = this.groups.flatMap(group => group.items);
        this.mediaTrack.append(...this.items.map(item => this.host.mediaSlides[item.index]));
        this.alignMedia(initialSlide);
        this.track = document.createElement('div');
        this.track.className = 'tbhnp-product-media-rail__track';
        this.groups.forEach((group, index) => {
          if (index && this.groups[index - 1].colour !== group.colour) {
            const el = document.createElement('span');
            el.className = 'tbhnp-product-media-rail__divider';
            el.setAttribute('aria-hidden', 'true');
            group.divider = { el, x: 0, tx: 0, v: 0, opacity: 1, targetOpacity: 1, opacityVelocity: 0, visible: true };
            this.track.append(el);
            this.animated.push(group.divider);
          }
          group.items.forEach(item => {
            if (item.position === 0 && group.items.length > 1) item.el.dataset.railCover = 'true';
            const originalLabel = item.el.getAttribute('aria-label') || '';
            item.el.setAttribute('aria-label', `${group.label} · ${originalLabel}`);
            this.track.append(item.el);
            this.animated.push(item);
          });
        });
        this.nav.replaceChildren(this.track);
        this.nav.setAttribute('data-tbhnp-rail-active', '');
        this.label = document.createElement('div');
        this.label.className = 'tbhnp-product-media-rail__label';
        this.label.setAttribute('aria-hidden', 'true');
        this.labelText = document.createElement('span');
        this.label.append(this.labelText);
        this.append(this.label);
        this.nav.addEventListener('click', event => this.onClick(event), { capture: true, signal: this.lifecycle.signal });
        this.nav.addEventListener('keydown', event => this.onKeydown(event), { signal: this.lifecycle.signal });
        this.nav.addEventListener('pointerdown', event => this.onPointerDown(event), { passive: true, signal: this.lifecycle.signal });
        this.nav.addEventListener('pointermove', event => this.onPointerMove(event), { signal: this.lifecycle.signal });
        this.nav.addEventListener('pointerup', event => this.onPointerEnd(event), { passive: true, signal: this.lifecycle.signal });
        this.nav.addEventListener('pointercancel', event => this.onPointerEnd(event, true), { passive: true, signal: this.lifecycle.signal });
        this.observer = new MutationObserver(records => {
          const record = records.find(record => record.target.getAttribute('aria-current') === 'true');
          if (record) this.syncActive(Number(record.target.dataset.mediaPage));
        });
        this.observer.observe(this.track, { subtree: true, attributes: true, attributeFilter: ['aria-current'] });
        this.mediaTrack.addEventListener('scroll', () => {
          window.clearTimeout(this.settleTimer);
          this.settleTimer = window.setTimeout(() => this.syncSettledMedia(), 180);
        }, { passive: true, signal: this.lifecycle.signal });
        this.mediaTrack.addEventListener('scrollend', () => this.syncSettledMedia(), { passive: true, signal: this.lifecycle.signal });
        ['pointerup', 'pointercancel', 'touchend', 'touchcancel'].forEach(type => {
          this.mediaTrack.addEventListener(type, () => {
            window.clearTimeout(this.settleTimer);
            this.settleTimer = window.setTimeout(() => this.syncSettledMedia(), 180);
          }, { passive: true, signal: this.lifecycle.signal });
        });
        this.resizeObserver = new ResizeObserver(() => {
          if (this.active && this.measuredWidth !== this.nav.clientWidth) this.layout(false);
        });
        this.resizeObserver.observe(this.nav);
        const current = this.items.find(item => item.el.getAttribute('aria-current') === 'true');
        if (current?.position > 0) this.openGroup = current.group;
        this.lastIndex = current?.index;
        this.settledIndex = current?.index;
        this.layout(false);
        if (current) this.revealItem(current);
        this.host.scheduleMediaThumbnailHydration?.();
      }

      deactivate() {
        if (!this.active) return;
        const currentIndex = this.host.mediaIndexFromScroll();
        const currentSlide = this.host.mediaSlides[currentIndex];
        this.host.cancelProgrammaticMediaScroll?.(false, true);
        this.active = false;
        this.lifecycle?.abort();
        this.observer?.disconnect();
        this.resizeObserver?.disconnect();
        window.cancelAnimationFrame(this.frame);
        window.clearTimeout(this.labelTimer);
        window.clearTimeout(this.suppressTimer);
        window.clearTimeout(this.settleTimer);
        if (this.pointer && this.nav.hasPointerCapture?.(this.pointer.id)) this.nav.releasePointerCapture(this.pointer.id);
        this.pointer = null;
        this.label?.remove();
        this.items.forEach(item => item.original.forEach(([name, value]) => {
          if (value === null) item.el.removeAttribute(name);
          else item.el.setAttribute(name, value);
        }));
        this.nav.removeAttribute('data-tbhnp-rail-active');
        this.nav.replaceChildren(...this.originalNodes);
        this.nav.scrollLeft = this.savedScroll;
        this.mediaTrack.replaceChildren(...this.originalMediaNodes);
        this.alignMedia(currentSlide);
        this.host.setActiveMedia(currentIndex, false, true);
        this.frame = 0;
      }

      alignMedia(slide) {
        if (!slide) return;
        const behavior = this.mediaTrack.style.scrollBehavior;
        this.mediaTrack.style.scrollBehavior = 'auto';
        this.mediaTrack.scrollTo({ left: slide.offsetLeft, behavior: 'auto' });
        this.mediaTrack.style.scrollBehavior = behavior;
        this.host.galleryLastScrollLeft = this.mediaTrack.scrollLeft;
      }

      syncSettledMedia() {
        if (!this.active || this.host.galleryPointerDown || this.host.programmaticMediaScroll) return;
        const index = this.host.mediaIndexFromScroll();
        if (index === this.settledIndex) return;
        this.settledIndex = index;
        const item = this.byIndex.get(index);
        if (!item) return;
        this.host.setActiveMedia(index, false, true);
        this.openGroup = item.group.items.length > 1 ? item.group : null;
        this.layout(true);
        this.revealItem(item);
        this.announce(item.group);
        this.syncColour(item, true);
      }

      onClick(event) {
        const button = event.target.closest('[data-media-page]');
        if (!button || !this.track.contains(button)) return;
        if (this.suppressClick) {
          this.suppressClick = false;
          event.preventDefault();
          event.stopImmediatePropagation();
          return;
        }
        const item = this.byIndex.get(Number(button.dataset.mediaPage));
        if (!item || !item.visible) {
          event.preventDefault();
          event.stopImmediatePropagation();
          return;
        }
        this.announce(item.group);
        this.settledIndex = item.index;
        if (item.position === 0) {
          this.openGroup = this.openGroup === item.group || item.group.items.length === 1 ? null : item.group;
          this.layout(true);
          this.revealGroup(item.group);
        }
        this.syncColour(item, true);
      }

      syncColour(item, preserveMedia = false) {
        if (item.group.colour && Number.isFinite(this.host.colorOptionIndex)) {
          const colourButton = this.host.optionButtons?.find(option => Number(option.dataset.optionIndex) === this.host.colorOptionIndex && option.dataset.optionValue === item.group.colour);
          if (colourButton && this.host.selectedOptions?.[this.host.colorOptionIndex] !== item.group.colour) {
            this.selectingThumbnail = true;
            try { this.host.selectOption(colourButton, { preserveMedia }); }
            finally { this.selectingThumbnail = false; }
          }
        }
      }

      syncActive(index) {
        if (!this.active) return;
        const item = this.byIndex.get(Number(index));
        if (!item) return;
        const changed = this.lastIndex !== item.index;
        this.lastIndex = item.index;
        if (item.position > 0 && this.openGroup !== item.group) {
          this.openGroup = item.group;
          this.layout(true);
        }
        this.updateCurrentGroup();
        if (changed && !this.selectingThumbnail) this.revealItem(item);
      }

      announce(group) {
        window.clearTimeout(this.labelTimer);
        this.labelText.textContent = group.label;
        this.label.dataset.visible = 'true';
        this.labelTimer = window.setTimeout(() => {
          if (this.label) this.label.dataset.visible = 'false';
        }, this.motion.matches ? 1000 : 850);
      }

      layout(animate) {
        if (!this.active) return;
        let x = 3;
        this.groups.forEach((group, groupIndex) => {
          if (groupIndex) x += group.divider ? 25 : 15;
          if (group.divider) group.divider.tx = x - 13;
          group.x = x;
          const open = this.openGroup === group;
          group.items.forEach(item => {
            item.visible = item.position === 0 || open;
            item.tx = x + (open ? item.position * 52 : 0);
            item.targetOpacity = item.visible ? 1 : 0;
            if (item.visible) item.el.hidden = false;
            if (!item.visible && item.el.contains(document.activeElement)) group.items[0].el.focus({ preventScroll: true });
            item.el.inert = !item.visible;
            item.el.setAttribute('aria-hidden', String(!item.visible));
            item.el.tabIndex = item.visible ? 0 : -1;
            item.el.style.pointerEvents = item.visible ? '' : 'none';
            item.el.style.zIndex = item.position === 0 ? '2' : '1';
            if (item.position === 0 && group.items.length > 1) item.el.setAttribute('aria-expanded', String(open));
          });
          x += 44 + (open ? (group.items.length - 1) * 52 : group.items.length > 1 ? 5 : 0);
        });
        this.measuredWidth = this.nav.clientWidth;
        this.updateCurrentGroup();
        this.targetWidth = Math.max(0, this.measuredWidth - 28, x + 8);
        this.trackWidth = Math.max(this.trackWidth, this.targetWidth);
        this.track.style.width = `${this.trackWidth}px`;
        if (!animate || this.motion.matches) {
          window.cancelAnimationFrame(this.frame);
          this.frame = 0;
          this.animated.forEach(item => {
            item.x = item.tx;
            item.opacity = item.targetOpacity;
            item.v = 0;
            item.opacityVelocity = 0;
          });
          this.draw();
          this.settle();
        } else if (!this.frame) {
          this.lastFrame = performance.now();
          this.frame = window.requestAnimationFrame(now => this.tick(now));
        }
      }

      tick(now) {
        if (!this.active) return;
        const dt = Math.min(0.025, Math.max(0.001, (now - this.lastFrame) / 1000));
        this.lastFrame = now;
        let moving = false;
        this.animated.forEach(item => {
          item.v += (576 * (item.tx - item.x) - 48 * item.v) * dt;
          item.x += item.v * dt;
          item.opacityVelocity += (576 * (item.targetOpacity - item.opacity) - 48 * item.opacityVelocity) * dt;
          item.opacity += item.opacityVelocity * dt;
          if (Math.abs(item.tx - item.x) < 0.06 && Math.abs(item.v) < 0.1) {
            item.x = item.tx;
            item.v = 0;
          } else moving = true;
          if (Math.abs(item.targetOpacity - item.opacity) < 0.001 && Math.abs(item.opacityVelocity) < 0.01) {
            item.opacity = item.targetOpacity;
            item.opacityVelocity = 0;
          } else moving = true;
        });
        this.draw();
        if (moving) this.frame = window.requestAnimationFrame(time => this.tick(time));
        else {
          this.frame = 0;
          this.settle();
        }
      }

      draw() {
        this.animated.forEach(item => {
          item.el.style.transform = `translate3d(${item.x.toFixed(3)}px, 0, 0)`;
          item.el.style.opacity = String(Math.max(0, Math.min(1, item.opacity)));
        });
      }

      updateCurrentGroup() {
        const current = this.byIndex.get(this.lastIndex);
        this.groups.forEach(group => {
          group.items[0].el.dataset.railCurrentGroup = String(current?.group === group && current.position > 0 && this.openGroup !== group);
        });
      }

      settle() {
        this.items.forEach(item => { item.el.hidden = !item.visible; });
        this.trackWidth = this.targetWidth;
        this.track.style.width = `${this.trackWidth}px`;
      }

      scrollTo(left) {
        if (this.pointer) return;
        const maximum = Math.max(0, this.targetWidth + 28 - this.nav.clientWidth);
        const target = Math.max(0, Math.min(maximum, left));
        if (Math.abs(target - this.nav.scrollLeft) < 1) return;
        this.nav.scrollTo({ left: target, behavior: this.motion.matches ? 'auto' : 'smooth' });
      }

      revealItem(item) {
        const start = item.tx + 14;
        const end = start + 49;
        const left = this.nav.scrollLeft;
        if (start < left + 14) this.scrollTo(start - 14);
        else if (end > left + this.nav.clientWidth - 14) this.scrollTo(end - this.nav.clientWidth + 14);
      }

      revealGroup(group) {
        const end = group.x + 44 + (this.openGroup === group ? (group.items.length - 1) * 52 : 5) + 62;
        const left = this.nav.scrollLeft;
        if (group.x < left + 3) this.scrollTo(group.x - 3);
        else if (end > left + this.nav.clientWidth - 28) this.scrollTo(Math.min(group.x - 3, end - this.nav.clientWidth + 28));
      }

      onKeydown(event) {
        if (!['ArrowLeft', 'ArrowRight', 'Home', 'End', 'Escape'].includes(event.key)) return;
        const current = this.byIndex.get(Number(event.target.dataset.mediaPage));
        if (!current) return;
        if (event.key === 'Escape') {
          if (!this.openGroup) return;
          const cover = this.openGroup.items[0];
          this.openGroup = null;
          cover.el.focus({ preventScroll: true });
          this.layout(true);
          this.revealItem(cover);
        } else {
          const visible = this.groups.flatMap(group => group.items.filter(item => item.visible));
          const currentIndex = visible.indexOf(current);
          const index = event.key === 'Home' ? 0 : event.key === 'End' ? visible.length - 1 : Math.max(0, Math.min(visible.length - 1, currentIndex + (event.key === 'ArrowRight' ? 1 : -1)));
          const target = visible[index];
          target?.el.focus({ preventScroll: true });
          if (target) this.revealItem(target);
        }
        event.preventDefault();
        event.stopPropagation();
      }

      onPointerDown(event) {
        this.suppressClick = false;
        window.clearTimeout(this.suppressTimer);
        if (event.pointerType !== 'mouse' || event.button !== 0) return;
        this.pointer = { id: event.pointerId, x: event.clientX, y: event.clientY, left: this.nav.scrollLeft, moved: false };
      }

      onPointerMove(event) {
        const pointer = this.pointer;
        if (!pointer || pointer.id !== event.pointerId) return;
        const deltaX = event.clientX - pointer.x;
        const deltaY = event.clientY - pointer.y;
        if (!pointer.moved && Math.abs(deltaY) > Math.abs(deltaX) && Math.abs(deltaY) > 6) {
          this.pointer = null;
          return;
        }
        if (Math.abs(deltaX) > 6) {
          pointer.moved = true;
          if (!this.nav.hasPointerCapture(event.pointerId)) this.nav.setPointerCapture(event.pointerId);
        }
        if (pointer.moved) {
          event.preventDefault();
          this.nav.scrollLeft = pointer.left - deltaX;
        }
      }

      onPointerEnd(event, cancelled = false) {
        if (!this.pointer || this.pointer.id !== event.pointerId) return;
        this.suppressClick = !cancelled && this.pointer.moved;
        this.pointer = null;
        if (this.nav.hasPointerCapture(event.pointerId)) this.nav.releasePointerCapture(event.pointerId);
        window.clearTimeout(this.suppressTimer);
        this.suppressTimer = window.setTimeout(() => { this.suppressClick = false; }, 0);
      }
    }

    customElements.define(elementName, TBHNPProductMediaRail);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["tbhnp-size-finder"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('tbhnp-size-finder')) {
    class TbhnpSizeFinder extends HTMLElement {
      connectedCallback() {
        if (this.dataset.initialized === 'true') return;
        this.dataset.initialized = 'true';

        this.form = this.querySelector('form');
        this.error = this.querySelector('.tbhnp-fit__error');
        this.result = this.querySelector('.tbhnp-fit__result');
        this.fitData = JSON.parse(this.dataset.fitData);
        this.sizes = this.fitData.sizes;
        this.measurementSlots = Array.from(this.querySelectorAll('[data-measurement]'));
        this.labels = {
          length: this.dataset.labelLength,
          chest: this.dataset.labelChest,
          shoulder: this.dataset.labelShoulder,
          sleeve: this.dataset.labelSleeve,
          waist: this.dataset.labelWaist,
          hip: this.dataset.labelHip,
          thigh: this.dataset.labelThigh,
          hem: this.dataset.labelHem,
        };

        this.lifecycle = new AbortController();
        const signal = this.lifecycle.signal;
        this.applyButton = this.querySelector('[data-apply-fit]');
        this.selectionStatus = this.querySelector('[data-fit-selection-status]');
        this.productSlide = this.closest('tbhnp-mobile-product-slide');
        this.form.addEventListener('submit', (event) => {
          event.preventDefault();
          this.calculate();
        }, { signal });
        this.form.addEventListener('input', () => {
          this.recommendedSize = null;
          this.applyButton.hidden = true;
          this.selectionStatus.hidden = true;
          this.result.hidden = true;
        }, { signal });
        this.productSlide?.addEventListener('tbhnp:selection-change', () => {
          this.selectionStatus.hidden = true;
          this.syncApplyButton();
        }, { signal });
        this.applyButton.addEventListener('click', () => {
          if (!this.recommendedSize) return;
          const selected = this.productSlide?.applyRecommendedSize(this.recommendedSize);
          this.selectionStatus.textContent = (selected ? this.dataset.sizeSelected : this.dataset.sizeUnavailable)
            .replace('__SIZE__', this.recommendedSize);
          this.selectionStatus.hidden = false;
          this.syncApplyButton();
        }, { signal });
      }

      disconnectedCallback() {
        this.lifecycle?.abort();
        delete this.dataset.initialized;
      }

      syncApplyButton() {
        if (!this.recommendedSize || !this.applyButton) return;
        this.applyButton.hidden = !this.productSlide;
        const available = Boolean(this.productSlide?.recommendedSizeVariant(this.recommendedSize)?.available);
        this.applyButton.disabled = !available || this.productSlide?.busy;
        this.applyButton.textContent = (available ? this.dataset.chooseSize : this.dataset.sizeUnavailable)
          .replace('__SIZE__', this.recommendedSize);
      }

      calculate() {
        const formData = new FormData(this.form);
        const height = Number(formData.get('height'));
        const weight = Number(formData.get('weight'));
        const fit = String(formData.get('fit'));

        if (height < 140 || height > 220 || weight < 35 || weight > 180) {
          this.error.hidden = false;
          this.result.hidden = true;
          return;
        }

        this.error.hidden = true;

        const score = ((height - this.fitData.model.height) / 8) * 0.7 + (weight - this.fitData.model.weight) / 10;
        let index = this.sizes.indexOf(this.fitData.model.size);

        if (index < 0) index = Math.floor(this.sizes.length / 2);

        if (score <= -1.15) index -= 1;
        if (score > 0.85) index += 1;
        if (score > 2.15) index += 1;
        if (fit === 'close') index -= 1;
        if (fit === 'oversized') index += 1;

        index = Math.max(0, Math.min(this.sizes.length - 1, index));
        const size = this.sizes[index];
        const garment = this.fitData.chart[size];
        const fitLabel = this.form.querySelector(`input[name="fit"][value="${fit}"] + span`).textContent.trim();

        this.recommendedSize = size;
        this.selectionStatus.hidden = true;
        this.syncApplyButton();
        this.querySelector('[data-size]').textContent = size;
        this.querySelector('[data-fit-label]').textContent = fitLabel;
        this.measurementSlots.forEach((slot, measurementIndex) => {
          const measurement = this.fitData.measurements[measurementIndex];
          const value = measurement ? garment[measurement.key] : null;

          slot.hidden = !measurement || value == null;
          if (slot.hidden) return;

          slot.querySelector('[data-measure-label]').textContent = this.labels[measurement.key] || measurement.label;
          slot.querySelector('[data-measure-value]').textContent = value;
        });
        this.result.hidden = false;
        const behavior = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
        this.result.scrollIntoView({ behavior, block: 'nearest' });
      }
    }

    customElements.define('tbhnp-size-finder', TbhnpSizeFinder);
  }
  } catch(e) { console.error(e); }
})();

})();
